export default {
    zh: {
        // 页面标题和描述
        pageTitle: 'OpenAI Sora-2 AI视频生成器 - 革命性AI视频创作工具',
        pageDescription:
            '体验OpenAI Sora-2 AI视频生成器，支持物理真实感、同步音频生成、高一致性等核心功能。在WeryAI平台免费试用，创造专业级AI视频内容。',
        pageKeywords:
            'Sora-2, OpenAI AI视频生成器, AI视频创作, 人工智能视频, 视频生成工具, 免费AI视频, WeryAI, 视频制作',

        // 生成器部分
        generatorTitle: 'OpenAI Sora-2 视频生成器',
        generatorDescription:
            'WeryAI 现已深度集成<span class="text-text-active">Sora 2</span>模型，这是对最初 Sora（2024 年 2 月）的重大改进，在真实感、物理精度、可控性和风格方面都取得了重大进步。Sora 2 可以遵循物理定律，并在多个镜头中保持一致的世界状态。它现在已在 <span class="text-text-active">WeryAI 视频生成器上可用，点击此处免费试用</span>！',

        // 标签页
        tabImageToVideo: '图生视频',
        tabTextToVideo: '文生视频',

        // 核心功能部分
        coreFeaturesTitle: 'Sora 2的主要功能',
        coreFeaturesSubtitle:
            '探索 OpenAI Sora-2 AI 视频生成器的核心功能，开启革命性的 AI 视频创作之旅',

        // 物理真实感功能
        physicalRealismTitle: '物理真实感',
        physicalRealismDescription:
            'Sora-2 能够精确模拟重力、浮力、物体碰撞和其他物理定律，生成具有高度物理真实感的视频内容，让您的创作更加逼真自然。',

        // 同步音频生成功能
        synchronizedAudioTitle: '同步音频生成',
        synchronizedAudioDescription:
            '集成语音、环境音效和背景音乐的生成，实现完美的音视频同步体验，让您的视频更加生动有趣。',

        // 高一致性功能
        highConsistencyTitle: '高一致性及多镜头叙事',
        highConsistencyDescription:
            '能够高度保真地遵循详细的多镜头提示，并在不同场景中保持世界状态的连贯性，创造完整的叙事体验。',

        // 真实世界人物形象植入功能
        realWorldCharacterTitle: '真实世界人物形象植入',
        realWorldCharacterDescription:
            '用户可以录制自己或他人的影像，并将这些影像真实地置入视频中，实现"客串"效果，并可以控制使用和撤销权限。',

        // 如何使用部分
        howToUseTitle: '如何使用',
        howToUseSubtitle: '简单三步，开始创作',
        step1Title: '选择Sora 2模型',
        step1Description:
            '前往<span class="highlight-text">"图像转视频AI"</span>页面，然后在模型下拉菜单中点击"Sora 2"。',
        step2Title: '输入您的详细提示词',
        step2Description: '描述您想要生成的内容，并选择您喜欢的视频配置。',
        step3Title: '下载您的视频',
        step3Description: '点击"创建"，即可随意下载或分享生成的视频。',

        // YouTube 视频部分
        youtubeTitle: '关于 Sora 2 视频模型的 YouTube 视频',
        youtubeVideosTitle: '关于 Sora 2 视频模型的 YouTube 视频',
        youtubeVideoTitle: '关于 Sora 2 视频模型的 YouTube 视频',

        // X Posts 部分
        xPostsTitle: '关于 Sora 2 视频模型的 X 帖子',

        // 探索其他模型部分
        exploreModelsTitle: '探索其他模型',
        veo31Title: 'Google Veo 3.1 AI 视频生成器',
        veo3Title: 'Google Veo 3 AI 视频生成器',
        veo3FastTitle: 'Google Veo 3 Fast AI 视频生成器',
        klingTitle: 'Kling AI 视频生成器',
        hailuoTitle: 'Hailuo AI 视频生成器',
        runwayTitle: 'Runway AI 视频生成器',
        seedanceTitle: 'Seedance 1.0 Pro 视频生成器',
        wanAITitle: 'Wan AI 视频生成器',

        // FAQ 部分
        faqTitle: '常见问题解答',

        // CTA 部分
        ctaTitle: '准备开始创作了吗？',
        ctaSubtitle: '立即体验 Sora 2，将您的创意转化为精彩视频',
        ctaDescription: '立即体验 Sora 2，将您的创意转化为精彩视频',
        ctaButton: '在WeryAI上试用Sora 2',
        ctaNote: '无需信用卡',
        ctaDisclaimer: '无需信用卡',

        // 视频播放相关
        videoNotSupported: '您的浏览器不支持视频播放',
        videoUnsupported: '您的浏览器不支持视频播放',
        videoLoadingError: '视频加载失败',
        videoLoadError: '视频加载失败',
        videoReload: '重新加载',
        sora2Tip: 'Sora 2对真人特写审核较严，建议上传远景或非正面照以提高成功率',
    },
    en: {
        // Page title and description
        pageTitle:
            'OpenAI Sora-2 AI Video Generator - Revolutionary AI Video Creation Tool',
        pageDescription:
            'Experience OpenAI Sora-2 AI video generator with physical realism, synchronized audio generation, high consistency and core features. Try it free on WeryAI platform and create professional AI video content.',
        pageKeywords:
            'Sora-2, OpenAI AI video generator, AI video creation, artificial intelligence video, video generation tool, free AI video, WeryAI, video production',

        // Generator section
        generatorTitle: 'OpenAI Sora-2 Video Generator',
        generatorDescription:
            'WeryAI now deeply integrates the <span class="text-text-active">Sora 2</span> model, a major improvement over the original Sora (February 2024), with significant advances in realism, physical accuracy, controllability, and style. Sora 2 can follow physical laws and maintain consistent world state across multiple shots. It\'s now available on <span class="text-text-active">WeryAI video generator, click here to try for free</span>!',

        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Sora 2 Main Features',
        coreFeaturesSubtitle:
            'Explore the core features of OpenAI Sora-2 AI video generator and embark on a revolutionary AI video creation journey',

        // Physical realism feature
        physicalRealismTitle: 'Physical Realism',
        physicalRealismDescription:
            'Sora-2 can accurately simulate gravity, buoyancy, object collisions, and other physical laws, generating video content with high physical realism, making your creations more realistic and natural.',

        // Synchronized audio generation feature
        synchronizedAudioTitle: 'Synchronized Audio Generation',
        synchronizedAudioDescription:
            'Integrates voice, environmental sound effects, and background music generation, achieving perfect audiovisual synchronization experience, making your videos more vivid and engaging.',

        // High consistency feature
        highConsistencyTitle: 'High Consistency and Multi-shot Narrative',
        highConsistencyDescription:
            'Can highly faithfully follow detailed multi-shot prompts and maintain world state coherence across different scenes, creating complete narrative experiences.',

        // Real world character feature
        realWorldCharacterTitle: 'Real World Character Integration',
        realWorldCharacterDescription:
            'Users can record images of themselves or others and realistically integrate these images into videos, achieving "cameo" effects with controllable usage and revocation permissions.',

        // How to use section
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Three simple steps to get started',
        step1Title: 'Select Sora 2 Model',
        step1Description:
            'Go to the <span class="highlight-text">"Image to Video AI"</span> page, then click "Sora 2" in the model dropdown menu.',
        step2Title: 'Enter Your Detailed Prompt',
        step2Description:
            'Describe what you want to generate and select your preferred video configuration.',
        step3Title: 'Download Your Video',
        step3Description:
            'Click "Create" to download or share your generated video.',

        // YouTube videos section
        youtubeTitle: 'YouTube Videos About Sora 2 Video Model',
        youtubeVideosTitle: 'YouTube Videos About Sora 2 Video Model',
        youtubeVideoTitle: 'YouTube Videos About Sora 2 Video Model',

        // X Posts section
        xPostsTitle: 'X Posts About Sora 2 Video Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Models',
        veo31Title: 'Google Veo 3.1 AI Video Generator',
        veo3Title: 'Google Veo 3 AI Video Generator',
        veo3FastTitle: 'Google Veo 3 Fast AI Video Generator',
        klingTitle: 'Kling AI Video Generator',
        hailuoTitle: 'Hailuo AI Video Generator',
        runwayTitle: 'Runway AI Video Generator',
        seedanceTitle: 'Seedance 1.0 Pro Video Generator',
        wanAITitle: 'Wan AI Video Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',

        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaSubtitle:
            'Experience Sora 2 now and transform your creativity into amazing videos',
        ctaDescription:
            'Experience Sora 2 now and transform your creativity into amazing videos',
        ctaButton: 'Try Sora 2 on WeryAI',
        ctaNote: 'No credit card required',
        ctaDisclaimer: 'No credit card required',

        // Video playback related
        videoNotSupported: 'Your browser does not support video playback',
        videoUnsupported: 'Your browser does not support video playback',
        videoLoadingError: 'Video loading failed',
        videoLoadError: 'Video failed to load',
        videoReload: 'Reload',
        sora2Tip: 'Sora 2 has strict review for real-person close-ups. It is recommended to upload long shots or non-frontal photos to improve the success rate.',
    },
    ja: {
        // ページタイトルと説明
        pageTitle:
            'OpenAI Sora-2 AI動画ジェネレーター - 革命的なAI動画作成ツール',
        pageDescription:
            'OpenAI Sora-2 AI動画ジェネレーターを体験。物理リアリズム、同期音声生成、高一貫性などコア機能をサポート。WeryAIプラットフォームで無料試用し、プロフェッショナルなAI動画コンテンツを作成。',
        pageKeywords:
            'Sora-2, OpenAI AI動画ジェネレーター, AI動画作成, 人工知能動画, 動画生成ツール, 無料AI動画, WeryAI, 動画制作',

        // ジェネレーター部分
        generatorTitle: 'OpenAI Sora-2 AI動画ジェネレーター',
        generatorDescription:
            'WeryAI はSora 2モデルを深く統合し、OpenAI Sora-2は、高品質で物理的にリアルな動画コンテンツを生成できる革命的なAI動画モデルです。2024年12月にリリースされ、物理リアリズム、音声同期、キャラクター一貫性において前世代のSora-1と比較して大幅な改善を実現しています。WeryAI動画ジェネレーターでSora-2を無料でお試しください！',

        // タブ
        tabImageToVideo: '画像から動画',
        tabTextToVideo: 'テキストから動画',

        // コア機能部分
        coreFeaturesTitle: 'Sora 2 の主要機能',
        coreFeaturesSubtitle:
            'OpenAI Sora-2 AI動画ジェネレーターのコア機能を探索し、革命的なAI動画作成の旅を始めましょう',

        // 物理リアリズム機能
        physicalRealismTitle: '物理リアリズム',
        physicalRealismDescription:
            'Sora-2は重力、浮力、物体衝突、その他の物理法則を正確にシミュレートし、高い物理リアリズムを持つ動画コンテンツを生成し、あなたの創作をよりリアルで自然にします。',

        // 同期音声生成機能
        synchronizedAudioTitle: '同期音声生成',
        synchronizedAudioDescription:
            '音声、環境音効果、背景音楽の生成を統合し、完璧な音響視覚同期体験を実現し、動画をより生き生きと魅力的にします。',

        // 高一貫性機能
        highConsistencyTitle: '高一貫性とマルチショット叙事',
        highConsistencyDescription:
            '詳細なマルチショットプロンプトに高度に忠実に従い、異なるシーン間で世界状態の一貫性を維持し、完全な叙事体験を作り出します。',

        // 実世界キャラクター統合機能
        realWorldCharacterTitle: '実世界キャラクター統合',
        realWorldCharacterDescription:
            'ユーザーは自分自身や他の人の画像を録画し、これらの画像を動画にリアルに統合し、「カメオ」効果を実現し、使用と取り消しの権限を制御できます。',

        // 使用方法部分
        howToUseTitle: '使用方法',
        howToUseSubtitle: '簡単3ステップで開始',
        step1Title: 'Sora 2モデル選択',
        step1Description:
            '「画像から動画AI」ページに移動し、モデルドロップダウンメニューで「Sora 2」をクリックします。',
        step2Title: 'コンテンツ入力',
        step2Description: 'プロンプトを入力または参照画像をアップロード',
        step3Title: '動画生成',
        step3Description: '生成ボタンをクリックし、待機して動画をダウンロード',

        // YouTube動画部分
        youtubeTitle: 'OpenAI Sora-2 AI動画モデルに関するYouTube動画',
        youtubeVideosTitle: 'OpenAI Sora-2 AI動画モデルに関するYouTube動画',
        youtubeVideoTitle: 'OpenAI Sora-2 AI動画モデルに関するYouTube動画',

        // X投稿部分
        xPostsTitle: 'Sora-2 AI動画モデルに関するX投稿',

        // 他のモデル探索部分
        exploreModelsTitle: '他の動画モデルを探索',
        veo31Title: 'Google Veo 3.1 AI動画ジェネレーター',
        veo3Title: 'Google Veo 3 AI動画ジェネレーター',
        veo3FastTitle: 'Google Veo 3 Fast AI動画ジェネレーター',
        klingTitle: 'Kling AI動画ジェネレーター',
        hailuoTitle: 'Hailuo AI動画ジェネレーター',
        runwayTitle: 'Runway AI動画ジェネレーター',
        seedanceTitle: 'Seedance 1.0 Pro 動画ジェネレーター',
        wanAITitle: 'Wan AI動画ジェネレーター',

        // FAQ部分
        faqTitle: 'よくある質問',

        // CTA部分
        ctaTitle: '作成を始める準備はできましたか？',
        ctaSubtitle:
            '今すぐSora-2を体験し、あなたの創造性を素晴らしい動画に変換',
        ctaDescription:
            '今すぐSora-2を体験し、あなたの創造性を素晴らしい動画に変換',
        ctaButton: 'WeryAIでSora-2を試す',
        ctaNote: 'クレジットカード不要',
        ctaDisclaimer: 'クレジットカード不要',

        // 動画再生関連
        videoNotSupported: 'お使いのブラウザは動画再生をサポートしていません',
        videoUnsupported: 'お使いのブラウザは動画再生をサポートしていません',
        videoLoadingError: '動画の読み込みに失敗しました',
        videoLoadError: '動画の読み込みに失敗しました',
        videoReload: '再読み込み',
        sora2Tip: 'Sora 2は実物の人物の接写に対して厳格な審査を行っています。成功率を高めるために、遠景や正面以外の写真をアップロードすることをお勧めします。',
    },
    ko: {
        // 페이지 제목과 설명
        pageTitle:
            'OpenAI Sora-2 AI 비디오 생성기 - 혁신적인 AI 비디오 제작 도구',
        pageDescription:
            'OpenAI Sora-2 AI 비디오 생성기를 체험하세요. 물리적 현실감, 동기화된 오디오 생성, 높은 일관성 등 핵심 기능을 지원합니다. WeryAI 플랫폼에서 무료로 체험하고 전문적인 AI 비디오 콘텐츠를 만드세요.',
        pageKeywords:
            'Sora-2, OpenAI AI 비디오 생성기, AI 비디오 제작, 인공지능 비디오, 비디오 생성 도구, 무료 AI 비디오, WeryAI, 비디오 제작',

        // 생성기 부분
        generatorTitle: 'OpenAI Sora-2 AI 비디오 생성기',
        generatorDescription:
            'WeryAI는 이제 Sora 2 모델을 심층 통합하여, OpenAI Sora-2는 고품질이고 물리적으로 현실적인 비디오 콘텐츠를 생성할 수 있는 혁신적인 AI 비디오 모델입니다. 2024년 12월에 출시되었으며, 물리적 현실감, 오디오 동기화, 캐릭터 일관성에서 전작인 Sora-1에 비해 상당한 개선을 보여줍니다. WeryAI 비디오 생성기에서 Sora-2를 무료로 체험해보세요!',

        // 탭
        tabImageToVideo: '이미지에서 비디오',
        tabTextToVideo: '텍스트에서 비디오',

        // 핵심 기능 부분
        coreFeaturesTitle: 'Sora 2 주요 기능',
        coreFeaturesSubtitle:
            'OpenAI Sora-2 AI 비디오 생성기의 핵심 기능을 탐색하고 혁신적인 AI 비디오 제작 여정을 시작하세요',

        // 물리적 현실감 기능
        physicalRealismTitle: '물리적 현실감',
        physicalRealismDescription:
            'Sora-2는 중력, 부력, 물체 충돌 및 기타 물리 법칙을 정확하게 시뮬레이션하여 높은 물리적 현실감을 가진 비디오 콘텐츠를 생성하고 창작을 더욱 현실적이고 자연스럽게 만듭니다.',

        // 동기화된 오디오 생성 기능
        synchronizedAudioTitle: '동기화된 오디오 생성',
        synchronizedAudioDescription:
            '음성, 환경음 효과, 배경음악 생성을 통합하여 완벽한 오디오비주얼 동기화 경험을 달성하고 비디오를 더욱 생생하고 매력적으로 만듭니다.',

        // 높은 일관성 기능
        highConsistencyTitle: '높은 일관성 및 멀티샷 내러티브',
        highConsistencyDescription:
            '상세한 멀티샷 프롬프트를 높은 충실도로 따르고 서로 다른 장면에서 세계 상태의 일관성을 유지하여 완전한 내러티브 경험을 만들어냅니다.',

        // 실세계 캐릭터 통합 기능
        realWorldCharacterTitle: '실세계 캐릭터 통합',
        realWorldCharacterDescription:
            '사용자는 자신이나 다른 사람의 이미지를 녹화하고 이러한 이미지를 비디오에 현실적으로 통합하여 "카메오" 효과를 달성하고 사용 및 취소 권한을 제어할 수 있습니다.',

        // 사용 방법 부분
        howToUseTitle: '사용 방법',
        howToUseSubtitle: '간단한 3단계로 시작',
        step1Title: 'Sora 2 모델 선택',
        step1Description:
            '"이미지에서 비디오 AI" 페이지로 이동한 다음 모델 드롭다운 메뉴에서 "Sora 2"를 클릭합니다.',
        step2Title: '콘텐츠 입력',
        step2Description: '프롬프트 입력 또는 참조 이미지 업로드',
        step3Title: '비디오 생성',
        step3Description: '생성 버튼 클릭, 대기 후 비디오 다운로드',

        // YouTube 비디오 부분
        youtubeTitle: 'OpenAI Sora-2 AI 비디오 모델에 대한 YouTube 비디오',
        youtubeVideosTitle:
            'OpenAI Sora-2 AI 비디오 모델에 대한 YouTube 비디오',
        youtubeVideoTitle: 'OpenAI Sora-2 AI 비디오 모델에 대한 YouTube 비디오',

        // X 게시물 부분
        xPostsTitle: 'Sora-2 AI 비디오 모델에 대한 X 게시물',

        // 다른 모델 탐색 부분
        exploreModelsTitle: '다른 비디오 모델 탐색',
        veo31Title: 'Google Veo 3.1 AI 비디오 생성기',
        veo3Title: 'Google Veo 3 AI 비디오 생성기',
        veo3FastTitle: 'Google Veo 3 Fast AI 비디오 생성기',
        klingTitle: 'Kling AI 비디오 생성기',
        hailuoTitle: 'Hailuo AI 비디오 생성기',
        runwayTitle: 'Runway AI 비디오 생성기',
        seedanceTitle: 'Seedance 1.0 Pro 비디오 생성기',
        wanAITitle: 'Wan AI 비디오 생성기',

        // FAQ 부분
        faqTitle: '자주 묻는 질문',

        // CTA 부분
        ctaTitle: '제작을 시작할 준비가 되셨나요?',
        ctaSubtitle:
            '지금 Sora-2를 체험하고 당신의 창의성을 놀라운 비디오로 변환하세요',
        ctaDescription:
            '지금 Sora-2를 체험하고 당신의 창의성을 놀라운 비디오로 변환하세요',
        ctaButton: 'WeryAI에서 Sora-2 체험하기',
        ctaNote: '신용카드 불필요',
        ctaDisclaimer: '신용카드 불필요',

        // 비디오 재생 관련
        videoNotSupported: '귀하의 브라우저는 비디오 재생을 지원하지 않습니다',
        videoUnsupported: '귀하의 브라우저는 비디오 재생을 지원하지 않습니다',
        videoLoadingError: '비디오 로딩 실패',
        videoLoadError: '비디오 로딩 실패',
        videoReload: '다시 로드',
        sora2Tip: 'Sora 2는 실물 인물의 접사에 대해 엄격한 심사를 진행하고 있습니다. 성공률을 높이기 위해 원경이나 정면이 아닌 사진을 업로드하는 것을 권장합니다.',
    },
    tw: {
        // 頁面標題和描述
        pageTitle: 'OpenAI Sora 2 - 物理級精確 AI 影片產生器 | 革命性 AI 影片創作工具',
        pageDescription:
            '體驗 OpenAI Sora-2 AI 影片產生器，支援物理真實感、同步音訊生成、高一致性等核心功能。在 WeryAI 平台免費試用，創造專業級 AI 影片內容。',
        pageKeywords:
            'Sora-2, OpenAI AI 影片產生器, AI 影片創作, 人工智慧影片, 影片生成工具, 免費 AI 影片, WeryAI, 影片製作',

        // 產生器部分
        generatorTitle: 'OpenAI Sora 2 影片產生器',
        generatorDescription:
            'WeryAI 現已深度整合<span class="text-text-active">Sora 2</span>模型，這是對最初 Sora（2024 年 2 月）的重大改進，在真實感、物理精度、可控性和風格方面都取得了重大進步。Sora 2 可以遵循物理定律，並在多個鏡頭中保持一致的世界狀態。它現在已在 <span class="text-text-active">WeryAI 影片產生器上可用，點擊此處免費試用</span>！',

        // 標籤頁
        tabImageToVideo: '圖生影片',
        tabTextToVideo: '文生影片',

        // 核心功能部分
        coreFeaturesTitle: 'Sora 2 的主要功能',
        coreFeaturesSubtitle:
            '探索 OpenAI Sora-2 AI 影片產生器的核心功能，開啟革命性的 AI 影片創作之旅',

        // 物理真實感功能
        physicalRealismTitle: '物理真實感',
        physicalRealismDescription:
            'Sora-2 能夠精確模擬重力、浮力、物體碰撞和其他物理定律，生成具有高度物理真實感的影片內容，讓您的創作更加逼真自然。',

        // 同步音訊生成功能
        synchronizedAudioTitle: '同步音訊生成',
        synchronizedAudioDescription:
            '整合語音、環境音效和背景音樂的生成，實現完美的音影片同步體驗，讓您的影片更加生動有趣。',

        // 高一致性功能
        highConsistencyTitle: '高一致性及多鏡頭敘事',
        highConsistencyDescription:
            '能夠高度保真地遵循詳細的多鏡頭提示，並在不同場景中保持世界狀態的連貫性，創造完整的敘事體驗。',

        // 真實世界人物形象植入功能
        realWorldCharacterTitle: '真實世界人物形象植入',
        realWorldCharacterDescription:
            '用戶可以錄製自己或他人的影像，並將這些影像真實地置入影片中，實現「客串」效果，並可以控制使用和撤銷權限。',

        // 如何使用部分
        howToUseTitle: '如何使用',
        howToUseSubtitle: '簡單三步，開始創作',
        step1Title: '選擇 Sora 2 模型',
        step1Description:
            '前往 <span class="highlight-text">「圖像轉影片 AI」</span> 頁面，然後在模型下拉選單中點擊「Sora 2」。',
        step2Title: '輸入您的詳細提示詞',
        step2Description: '描述您想要生成的內容，並選擇您喜歡的影片配置。',
        step3Title: '下載您的影片',
        step3Description: '點擊「建立」，即可隨意下載或分享生成的影片。',

        // YouTube 影片部分
        youtubeTitle: '關於 Sora 2 影片模型的 YouTube 影片',
        youtubeVideosTitle: '關於 Sora 2 影片模型的 YouTube 影片',
        youtubeVideoTitle: '關於 Sora 2 影片模型的 YouTube 影片',

        // X Posts 部分
        xPostsTitle: '關於 Sora 2 影片模型的 X 貼文',

        // 探索其他模型部分
        exploreModelsTitle: '探索其他模型',
        veo31Title: 'Google Veo 3.1 AI 影片產生器',
        veo3Title: 'Google Veo 3 AI 影片產生器',
        veo3FastTitle: 'Google Veo 3 Fast AI 影片產生器',
        klingTitle: 'Kling AI 影片產生器',
        hailuoTitle: 'Hailuo AI 影片產生器',
        runwayTitle: 'Runway AI 影片產生器',
        seedanceTitle: 'Seedance 1.0 Pro 影片產生器',
        wanAITitle: 'Wan AI 影片產生器',

        // FAQ 部分
        faqTitle: '常見問題解答',

        // CTA 部分
        ctaTitle: '準備開始創作了嗎？',
        ctaSubtitle: '立即體驗 Sora 2，將您的創意轉化為精彩影片',
        ctaDescription: '立即體驗 Sora 2，將您的創意轉化為精彩影片',
        ctaButton: '在 WeryAI 上試用 Sora 2',
        ctaNote: '無需信用卡',
        ctaDisclaimer: '無需信用卡',

        // 影片播放相關
        videoNotSupported: '您的瀏覽器不支援影片播放',
        videoUnsupported: '您的瀏覽器不支援影片播放',
        videoLoadingError: '影片載入失敗',
        videoLoadError: '影片載入失敗',
        videoReload: '重新載入',
        sora2Tip: 'Sora 2 對真人特寫審核較嚴，建議上傳遠景或非正面照以提高成功率',
    },
    pl: {
        // Page title and description
        pageTitle:
            'Generator wideo AI OpenAI Sora-2 - rewolucyjne narzędzie do tworzenia wideo AI',
        pageDescription:
            'Wypróbuj generator wideo AI OpenAI Sora-2 z realizmem fizycznym, zsynchronizowanym generowaniem dźwięku, wysoką spójnością i kluczowymi funkcjami. Wypróbuj za darmo na platformie WeryAI i twórz profesjonalne treści wideo AI.',
        pageKeywords:
            'Sora-2, generator wideo AI OpenAI, tworzenie wideo AI, sztuczna inteligencja wideo, narzędzie do generowania wideo, darmowe wideo AI, WeryAI, produkcja wideo',

        // Generator section
        generatorTitle: 'Generator wideo OpenAI Sora-2',
        generatorDescription:
            'WeryAI jest teraz głęboko zintegrowane z modelem <span class="text-text-active">Sora 2</span>, znaczące ulepszenie w stosunku do oryginalnej Sory (luty 2024), ze znaczącymi postępami w realizmie, dokładności fizycznej, sterowalności i stylu. Sora 2 może przestrzegać praw fizyki i utrzymywać spójny stan świata w wielu ujęciach. Jest już dostępna w <span class="text-text-active">generatorze wideo WeryAI, kliknij tutaj, aby wypróbować za darmo</span>!',

        // Tabs
        tabImageToVideo: 'Obraz na wideo',
        tabTextToVideo: 'Tekst na wideo',

        // Core features section
        coreFeaturesTitle: 'Główne funkcje Sora 2',
        coreFeaturesSubtitle:
            'Poznaj kluczowe funkcje generatora wideo AI OpenAI Sora-2 i rozpocznij rewolucyjną podróż w tworzeniu wideo AI',

        // Physical realism feature
        physicalRealismTitle: 'Realizm fizyczny',
        physicalRealismDescription:
            'Sora-2 potrafi dokładnie symulować grawitację, wyporność, kolizje obiektów i inne prawa fizyki, generując treści wideo o wysokim realizmie fizycznym, dzięki czemu Twoje kreacje stają się bardziej realistyczne i naturalne.',

        // Synchronized audio generation feature
        synchronizedAudioTitle: 'Zsynchronizowane generowanie dźwięku',
        synchronizedAudioDescription:
            'Integruje generowanie głosu, efektów dźwiękowych otoczenia i muzyki w tle, zapewniając doskonałą synchronizację audiowizualną, sprawiając, że Twoje filmy stają się bardziej żywe i angażujące.',

        // High consistency feature
        highConsistencyTitle: 'Wysoka spójność i wielowątkowa narracja',
        highConsistencyDescription:
            'Potrafi niezwykle wiernie podążać za szczegółowymi podpowiedziami wieloujęciowymi i zachowywać spójność stanu świata w różnych scenach, tworząc kompletne doświadczenia narracyjne.',

        // Real world character feature
        realWorldCharacterTitle: 'Integracja postaci ze świata rzeczywistego',
        realWorldCharacterDescription:
            'Użytkownicy mogą nagrywać wizerunki własne lub innych osób i realistycznie integrować je z filmami, uzyskując efekty "cameo" z kontrolowanymi uprawnieniami do użycia i ich odwołania.',

        // How to use section
        howToUseTitle: 'Jak używać',
        howToUseSubtitle: 'Trzy proste kroki, aby zacząć',
        step1Title: 'Wybierz model Sora 2',
        step1Description:
            'Przejdź do strony <span class="highlight-text">"AI Obraz na wideo"</span>, a następnie kliknij "Sora 2" w rozwijanym menu modeli.',
        step2Title: 'Wprowadź szczegółowy opis',
        step2Description:
            'Opisz, co chcesz wygenerować i wybierz preferowaną konfigurację wideo.',
        step3Title: 'Pobierz swoje wideo',
        step3Description:
            'Kliknij "Utwórz", aby pobrać lub udostępnić wygenerowane wideo.',

        // YouTube videos section
        youtubeTitle: 'Filmy na YouTube o modelu wideo Sora 2',
        youtubeVideosTitle: 'Filmy na YouTube o modelu wideo Sora 2',
        youtubeVideoTitle: 'Filmy na YouTube o modelu wideo Sora 2',

        // X Posts section
        xPostsTitle: 'Posty na X o modelu wideo Sora 2',

        // Explore other models section
        exploreModelsTitle: 'Poznaj inne modele',
        veo31Title: 'Generator wideo AI Google Veo 3.1',
        veo3Title: 'Generator wideo AI Google Veo 3',
        veo3FastTitle: 'Generator wideo AI Google Veo 3 Fast',
        klingTitle: 'Generator wideo AI Kling',
        hailuoTitle: 'Generator wideo AI Hailuo',
        runwayTitle: 'Generator wideo AI Runway',
        seedanceTitle: 'Generator wideo Seedance 1.0 Pro',
        wanAITitle: 'Generator wideo Wan AI',

        // FAQ section
        faqTitle: 'Często zadawane pytania',

        // CTA section
        ctaTitle: 'Gotowy, aby zacząć tworzyć?',
        ctaSubtitle:
            'Doświadcz Sora 2 już teraz i przekształć swoją kreatywność w niesamowite filmy',
        ctaDescription:
            'Doświadcz Sora 2 już teraz i przekształć swoją kreatywność w niesamowite filmy',
        ctaButton: 'Wypróbuj Sora 2 na WeryAI',
        ctaNote: 'Karta kredytowa nie jest wymagana',
        ctaDisclaimer: 'Karta kredytowa nie jest wymagana',

        // Video playback related
        videoNotSupported: 'Twoja przeglądarka nie obsługuje odtwarzania wideo',
        videoUnsupported: 'Twoja przeglądarka nie obsługuje odtwarzania wideo',
        videoLoadingError: 'Ładowanie wideo nie powiodło się',
        videoLoadError: 'Ładowanie wideo nie powiodło się',
        videoReload: 'Odśwież',
        sora2Tip: 'Sora 2 ma rygorystyczne zasady weryfikacji zbliżeń na twarze prawdziwych osób. Zaleca się przesyłanie planów ogólnych lub zdjęć z profilu, aby zwiększyć szansę na sukces.',
    },
    es: {
        // Título y descripción de la página
        pageTitle:
            'Generador de videos con IA OpenAI Sora-2 - Herramienta revolucionaria de creación de videos con IA | WeryAI',
        pageDescription:
            'Experimenta el generador de videos con IA Sora-2 de OpenAI con realismo físico, generación de audio sincronizada, alta consistencia y funciones clave. Pruébalo gratis en la plataforma WeryAI y crea contenido de video profesional con IA.',
        pageKeywords:
            'Sora-2, generador de video con IA de OpenAI, creación de video con IA, video de inteligencia artificial, herramienta de generación de video, video con IA gratis, WeryAI, producción de video',

        // Sección del generador
        generatorTitle: 'Generador de videos OpenAI Sora-2',
        generatorDescription:
            'WeryAI ahora integra profundamente el modelo <span class="text-text-active">Sora 2</span>, una gran mejora sobre el Sora original (febrero de 2024), con avances significativos en realismo, precisión física, control y estilo. Sora 2 puede seguir las leyes físicas y mantener un estado del mundo consistente en múltiples tomas. Ahora está disponible en el <span class="text-text-active">generador de video de WeryAI, haz clic aquí para probarlo gratis</span>!',

        // Pestañas
        tabImageToVideo: 'Imagen a video',
        tabTextToVideo: 'Texto a video',

        // Sección de funciones principales
        coreFeaturesTitle: 'Funciones principales de Sora 2',
        coreFeaturesSubtitle:
            'Explora las funciones clave del generador de videos con IA OpenAI Sora-2 y comienza un viaje revolucionario de creación de videos con IA',

        // Función de realismo físico
        physicalRealismTitle: 'Realismo físico',
        physicalRealismDescription:
            'Sora-2 puede simular con precisión la gravedad, la flotabilidad, las colisiones de objetos y otras leyes físicas, generando contenido de video con un elevado realismo físico, lo que hace que tus creaciones resulten más realistas y naturales.',

        // Función de audio sincronizado
        synchronizedAudioTitle: 'Generación de audio sincronizada',
        synchronizedAudioDescription:
            'Integra la generación de voces, efectos de sonido ambientales y música de fondo para lograr una experiencia audiovisual perfectamente sincronizada, haciendo tus videos más vivos y atractivos.',

        // Función de alta consistencia
        highConsistencyTitle: 'Alta consistencia y narrativa multiescena',
        highConsistencyDescription:
            'Puede seguir fielmente indicaciones detalladas con múltiples tomas y mantener la coherencia del estado del mundo a través de distintas escenas, creando experiencias narrativas completas.',

        // Función de integración de personajes reales
        realWorldCharacterTitle: 'Integración de personajes reales',
        realWorldCharacterDescription:
            'Los usuarios pueden grabar imágenes de sí mismos u otras personas e integrarlas de forma realista en los videos, logrando efectos de "cameo" con permisos de uso y revocación controlables.',

        // Sección de cómo usar
        howToUseTitle: 'Cómo usarlo',
        howToUseSubtitle: 'Comienza en tres pasos sencillos',
        step1Title: 'Selecciona el modelo Sora 2',
        step1Description:
            'Ve a la página <span class="highlight-text">"Imagen a video IA"</span> y luego haz clic en "Sora 2" en el menú desplegable de modelos.',
        step2Title: 'Introduce tu prompt detallado',
        step2Description:
            'Describe lo que deseas generar y elige tu configuración de video preferida.',
        step3Title: 'Descarga tu video',
        step3Description:
            'Haz clic en "Crear" para descargar o compartir el video generado.',

        // Sección de videos de YouTube
        youtubeTitle: 'Videos de YouTube sobre el modelo de video Sora 2',
        youtubeVideosTitle: 'Videos de YouTube sobre el modelo de video Sora 2',
        youtubeVideoTitle: 'Videos de YouTube sobre el modelo de video Sora 2',

        // Sección de publicaciones en X
        xPostsTitle: 'Publicaciones en X sobre el modelo de video Sora 2',

        // Sección de explorar otros modelos
        exploreModelsTitle: 'Explora otros modelos',
        veo31Title: 'Generador de video con IA Google Veo 3.1',
        veo3Title: 'Generador de video con IA Google Veo 3',
        veo3FastTitle: 'Generador de video con IA Google Veo 3 Fast',
        klingTitle: 'Generador de video con IA Kling',
        hailuoTitle: 'Generador de video con IA Hailuo',
        runwayTitle: 'Generador de video con IA Runway',
        seedanceTitle: 'Generador de video Seedance 1.0 Pro',
        wanAITitle: 'Generador de video con IA Wan',

        // Sección de preguntas frecuentes
        faqTitle: 'Preguntas frecuentes',

        // Sección de CTA
        ctaTitle: '¿Listo para empezar a crear?',
        ctaSubtitle:
            'Experimenta Sora 2 ahora y convierte tu creatividad en videos increíbles',
        ctaDescription:
            'Experimenta Sora 2 ahora y convierte tu creatividad en videos increíbles',
        ctaButton: 'Prueba Sora 2 en WeryAI',
        ctaNote: 'No se requiere tarjeta de crédito',
        ctaDisclaimer: 'No se requiere tarjeta de crédito',

        // Reproducción de video
        videoNotSupported: 'Tu navegador no admite la reproducción de video',
        videoUnsupported: 'Tu navegador no admite la reproducción de video',
        videoLoadingError: 'Error al cargar el video',
        videoLoadError: 'Error al cargar el video',
        videoReload: 'Recargar',
        sora2Tip: 'Sora 2 tiene una revisión estricta para los primeros planos de personas reales. Se recomienda subir fotos de planos generales o no frontales para mejorar la tasa de éxito.',
    },
    fr: {
        // Titre et description de la page
        pageTitle:
            'Générateur vidéo IA OpenAI Sora-2 - Outil révolutionnaire de création vidéo IA | WeryAI',
        pageDescription:
            "Découvrez le générateur vidéo IA Sora-2 d'OpenAI, avec réalisme physique, génération audio synchronisée, haute cohérence et fonctions clés. Essayez-le gratuitement sur la plateforme WeryAI et créez des vidéos professionnelles avec l'IA.",
        pageKeywords:
            'Sora-2, générateur vidéo IA OpenAI, création vidéo IA, vidéo intelligence artificielle, outil de génération vidéo, vidéo IA gratuite, WeryAI, production vidéo',

        // Section du générateur
        generatorTitle: 'Générateur vidéo OpenAI Sora-2',
        generatorDescription:
            'WeryAI intègre désormais en profondeur le modèle <span class="text-text-active">Sora 2</span>, une amélioration majeure par rapport au Sora original (février 2024), avec des avancées significatives en réalisme, précision physique, contrôlabilité et style. Sora 2 respecte les lois physiques et maintient un état du monde cohérent sur plusieurs plans. Il est désormais disponible sur le <span class="text-text-active">générateur vidéo WeryAI, cliquez ici pour l\'essayer gratuitement</span>!',

        // Onglets
        tabImageToVideo: 'Image vers vidéo',
        tabTextToVideo: 'Texte vers vidéo',

        // Section des fonctionnalités principales
        coreFeaturesTitle: 'Fonctionnalités principales de Sora 2',
        coreFeaturesSubtitle:
            'Explorez les fonctionnalités clés du générateur vidéo IA OpenAI Sora-2 et lancez un parcours de création vidéo révolutionnaire',

        // Fonction de réalisme physique
        physicalRealismTitle: 'Réalisme physique',
        physicalRealismDescription:
            "Sora-2 peut simuler avec précision la gravité, la flottabilité, les collisions d'objets et d'autres lois physiques, générant un contenu vidéo au réalisme physique élevé pour rendre vos créations plus réalistes et naturelles.",

        // Fonction d\'audio synchronisé
        synchronizedAudioTitle: 'Génération audio synchronisée',
        synchronizedAudioDescription:
            "Intègre la génération de voix, d'effets sonores d'ambiance et de musique de fond pour offrir une expérience audiovisuelle parfaitement synchronisée et rendre vos vidéos plus vivantes et captivantes.",

        // Fonction de haute cohérence
        highConsistencyTitle: 'Haute cohérence et narration multi-plans',
        highConsistencyDescription:
            "Suit fidèlement des prompts détaillés multi-plans et maintient la cohérence de l'état du monde à travers différentes scènes, créant des expériences narratives complètes.",

        // Fonction d\'intégration de personnages réels
        realWorldCharacterTitle: 'Intégration de personnages réels',
        realWorldCharacterDescription:
            "Les utilisateurs peuvent enregistrer des images d'eux-mêmes ou d'autres personnes et les intégrer de manière réaliste dans les vidéos, obtenant un effet \"caméo\" tout en contrôlant les autorisations d'utilisation et de révocation.",

        // Section utilisation
        howToUseTitle: "Comment l'utiliser",
        howToUseSubtitle: 'Trois étapes simples pour commencer',
        step1Title: 'Sélectionnez le modèle Sora 2',
        step1Description:
            'Accédez à la page <span class="highlight-text">"Image vers vidéo IA"</span>, puis sélectionnez "Sora 2" dans le menu déroulant des modèles.',
        step2Title: 'Saisissez votre prompt détaillé',
        step2Description:
            'Décrivez le contenu que vous souhaitez générer et choisissez votre configuration vidéo préférée.',
        step3Title: 'Téléchargez votre vidéo',
        step3Description:
            'Cliquez sur "Créer" pour télécharger ou partager la vidéo générée.',

        // Section vidéo YouTube
        youtubeTitle: 'Vidéos YouTube sur le modèle vidéo Sora 2',
        youtubeVideosTitle: 'Vidéos YouTube sur le modèle vidéo Sora 2',
        youtubeVideoTitle: 'Vidéos YouTube sur le modèle vidéo Sora 2',

        // Section publications X
        xPostsTitle: 'Publications X sur le modèle vidéo Sora 2',

        // Section explorer d\'autres modèles
        exploreModelsTitle: "Explorer d'autres modèles",
        veo31Title: 'Générateur vidéo IA Google Veo 3.1',
        veo3Title: 'Générateur vidéo IA Google Veo 3',
        veo3FastTitle: 'Générateur vidéo IA Google Veo 3 Fast',
        klingTitle: 'Générateur vidéo IA Kling',
        hailuoTitle: 'Générateur vidéo IA Hailuo',
        runwayTitle: 'Générateur vidéo IA Runway',
        seedanceTitle: 'Générateur vidéo Seedance 1.0 Pro',
        wanAITitle: 'Générateur vidéo IA Wan',

        // Section FAQ
        faqTitle: 'Questions fréquentes',

        // Section CTA
        ctaTitle: 'Prêt à commencer à créer ?',
        ctaSubtitle:
            'Découvrez Sora 2 dès maintenant et transformez votre créativité en vidéos incroyables',
        ctaDescription:
            'Découvrez Sora 2 dès maintenant et transformez votre créativité en vidéos incroyables',
        ctaButton: 'Essayer Sora 2 sur WeryAI',
        ctaNote: 'Aucune carte bancaire requise',
        ctaDisclaimer: 'Aucune carte bancaire requise',

        // Lecture vidéo
        videoNotSupported:
            'Votre navigateur ne prend pas en charge la lecture vidéo',
        videoUnsupported:
            'Votre navigateur ne prend pas en charge la lecture vidéo',
        videoLoadingError: 'Échec du chargement de la vidéo',
        videoLoadError: 'Échec du chargement de la vidéo',
        videoReload: 'Recharger',
        sora2Tip: 'Sora 2 a un examen strict pour les gros plans de personnes réelles. Il est recommandé de télécharger des photos de plans larges ou non frontales pour améliorer le taux de réussite.',
    },
    de: {
        // Seitenüberschrift und Beschreibung
        pageTitle:
            'OpenAI Sora-2 KI-Videogenerator – Revolutionäres KI-Videoerstellungstool | WeryAI',
        pageDescription:
            'Erleben Sie den OpenAI Sora-2 KI-Videogenerator mit physikalischem Realismus, synchroner Audiogenerierung, hoher Konsistenz und Kernfunktionen. Testen Sie ihn kostenlos auf der WeryAI-Plattform und erstellen Sie professionelle KI-Videoinhalte.',
        pageKeywords:
            'Sora-2, OpenAI KI-Videogenerator, KI-Videoerstellung, KI-Video, Videogenerierungstool, kostenloses KI-Video, WeryAI, Videoproduktion',

        // Generatorabschnitt
        generatorTitle: 'OpenAI Sora-2 Videogenerator',
        generatorDescription:
            'WeryAI integriert jetzt das Modell <span class="text-text-active">Sora 2</span> tiefgreifend, eine große Weiterentwicklung gegenüber dem ursprünglichen Sora (Februar 2024) mit bedeutenden Fortschritten bei Realismus, physikalischer Genauigkeit, Steuerbarkeit und Stil. Sora 2 befolgt physikalische Gesetzmäßigkeiten und hält den Weltzustand über mehrere Einstellungen hinweg konsistent. Jetzt verfügbar im <span class="text-text-active">WeryAI-Videogenerator – hier klicken, um es kostenlos zu testen</span>!',

        // Tabs
        tabImageToVideo: 'Bild zu Video',
        tabTextToVideo: 'Text zu Video',

        // Abschnitt Kernfunktionen
        coreFeaturesTitle: 'Hauptfunktionen von Sora 2',
        coreFeaturesSubtitle:
            'Entdecken Sie die Kernfunktionen des OpenAI Sora-2 KI-Videogenerators und starten Sie eine revolutionäre KI-Videoerstellung',

        // Funktion physikalischer Realismus
        physicalRealismTitle: 'Physikalischer Realismus',
        physicalRealismDescription:
            'Sora-2 simuliert präzise Schwerkraft, Auftrieb, Objektkollisionen und andere physikalische Gesetze und erzeugt Videoinhalte mit hohem physikalischem Realismus, sodass Ihre Produktionen natürlicher wirken.',

        // Funktion synchronisierte Audiogenerierung
        synchronizedAudioTitle: 'Synchronisierte Audiogenerierung',
        synchronizedAudioDescription:
            'Integriert Sprach-, Umgebungsgeräusch- und Hintergrundmusikgenerierung, um eine perfekt synchronisierte audiovisuelle Erfahrung zu bieten und Ihre Videos lebendiger zu machen.',

        // Funktion hohe Konsistenz
        highConsistencyTitle: 'Hohe Konsistenz und Multishot-Erzählung',
        highConsistencyDescription:
            'Folgt detailreichen Multishot-Prompts äußerst genau und wahrt die Kohärenz des Weltzustands in unterschiedlichen Szenen, um vollständige Erzählungen zu schaffen.',

        // Funktion Integration realer Personen
        realWorldCharacterTitle: 'Integration realer Personen',
        realWorldCharacterDescription:
            'Nutzer können Aufnahmen von sich selbst oder anderen erstellen und diese realistisch in Videos einfügen, um Cameo-Effekte mit kontrollierbaren Nutzungs- und Widerrufsrechten zu erzielen.',

        // Abschnitt Anwendung
        howToUseTitle: 'So funktioniert es',
        howToUseSubtitle: 'In drei einfachen Schritten starten',
        step1Title: 'Sora 2 Modell auswählen',
        step1Description:
            'Wechseln Sie zur Seite <span class="highlight-text">"Bild zu Video KI"</span> und wählen Sie im Modell-Dropdown "Sora 2".',
        step2Title: 'Eingabe Ihres detaillierten Prompts',
        step2Description:
            'Beschreiben Sie, was Sie erzeugen möchten, und wählen Sie Ihre bevorzugte Videokonfiguration.',
        step3Title: 'Video herunterladen',
        step3Description:
            'Klicken Sie auf "Erstellen", um Ihr generiertes Video herunterzuladen oder zu teilen.',

        // YouTube-Abschnitt
        youtubeTitle: 'YouTube-Videos zum Sora 2 Videomodell',
        youtubeVideosTitle: 'YouTube-Videos zum Sora 2 Videomodell',
        youtubeVideoTitle: 'YouTube-Videos zum Sora 2 Videomodell',

        // X-Beiträge Abschnitt
        xPostsTitle: 'X-Beiträge zum Sora 2 Videomodell',

        // Weitere Modelle
        exploreModelsTitle: 'Weitere Modelle entdecken',
        veo31Title: 'Google Veo 3.1 KI-Videogenerator',
        veo3Title: 'Google Veo 3 KI-Videogenerator',
        veo3FastTitle: 'Google Veo 3 Fast KI-Videogenerator',
        klingTitle: 'Kling KI-Videogenerator',
        hailuoTitle: 'Hailuo KI-Videogenerator',
        runwayTitle: 'Runway KI-Videogenerator',
        seedanceTitle: 'Seedance 1.0 Pro Videogenerator',
        wanAITitle: 'Wan KI-Videogenerator',

        // FAQ
        faqTitle: 'Häufige Fragen',

        // CTA
        ctaTitle: 'Bereit, mit dem Erstellen zu beginnen?',
        ctaSubtitle:
            'Erleben Sie Sora 2 jetzt und verwandeln Sie Ihre Kreativität in beeindruckende Videos',
        ctaDescription:
            'Erleben Sie Sora 2 jetzt und verwandeln Sie Ihre Kreativität in beeindruckende Videos',
        ctaButton: 'Sora 2 bei WeryAI testen',
        ctaNote: 'Keine Kreditkarte erforderlich',
        ctaDisclaimer: 'Keine Kreditkarte erforderlich',

        // Videowiedergabe
        videoNotSupported: 'Ihr Browser unterstützt keine Videowiedergabe',
        videoUnsupported: 'Ihr Browser unterstützt keine Videowiedergabe',
        videoLoadingError: 'Video konnte nicht geladen werden',
        videoLoadError: 'Video konnte nicht geladen werden',
        videoReload: 'Neu laden',
        sora2Tip: 'Sora 2 hat eine strenge Prüfung für Nahaufnahmen von echten Personen. Es wird empfohlen, Weitwinkelaufnahmen oder nicht-frontale Fotos hochzuladen, um die Erfolgsquote zu erhöhen.',
    },
    ru: {
        // Заголовок и описание страницы
        pageTitle:
            'Генератор видео OpenAI Sora-2 на базе ИИ — революционный инструмент создания видео | WeryAI',
        pageDescription:
            'Оцените генератор видео OpenAI Sora-2 с физическим реализмом, синхронной генерацией аудио, высокой согласованностью и ключевыми функциями. Попробуйте бесплатно на платформе WeryAI и создайте профессиональный контент на базе ИИ.',
        pageKeywords:
            'Sora-2, генератор видео OpenAI, создание видео с ИИ, видео на основе искусственного интеллекта, инструмент генерации видео, бесплатное видео с ИИ, WeryAI, видеопроизводство',

        // Раздел генератора
        generatorTitle: 'Генератор видео OpenAI Sora-2',
        generatorDescription:
            'WeryAI теперь глубоко интегрировал модель <span class="text-text-active">Sora 2</span>, физической точности, управляемости и стиле. Sora 2 соблюдает законы физики и сохраняет целостность мира в нескольких кадрах. Теперь модель доступна в <span class="text-text-active">видеогенераторе WeryAI, нажмите здесь, чтобы попробовать бесплатно</span>!',

        // Вкладки
        tabImageToVideo: 'Изображение в видео',
        tabTextToVideo: 'Текст в видео',

        // Основные функции
        coreFeaturesTitle: 'Основные функции Sora 2',
        coreFeaturesSubtitle:
            'Изучите ключевые возможности генератора видео OpenAI Sora-2 и начните революционное путешествие по созданию видео с ИИ',

        // Реализм
        physicalRealismTitle: 'Физический реализм',
        physicalRealismDescription:
            'Sora-2 точно моделирует гравитацию, плавучесть, столкновения объектов и другие физические законы, создавая видеоконтент с высоким уровнем физического реализма и делая ваши проекты более естественными.',

        // Синхронный звук
        synchronizedAudioTitle: 'Синхронная генерация аудио',
        synchronizedAudioDescription:
            'Интегрирует генерацию речи, фоновых эффектов и музыки, обеспечивая идеально синхронизированный аудиовизуальный опыт и делая видео более живыми и увлекательными.',

        // Высокая согласованность
        highConsistencyTitle: 'Высокая согласованность и многокадровый сюжет',
        highConsistencyDescription:
            'Точно следует подробным многокадровым промптам и поддерживает целостность мира в различных сценах, создавая завершенный сюжетный опыт.',

        // Реальные персонажи
        realWorldCharacterTitle: 'Интеграция реальных персонажей',
        realWorldCharacterDescription:
            'Пользователи могут записывать себя или других людей и реалистично внедрять эти образы в видео, получая эффект "камео" с контролируемыми правами использования и отзыва.',

        // Как использовать
        howToUseTitle: 'Как использовать',
        howToUseSubtitle: 'Начните всего за три шага',
        step1Title: 'Выберите модель Sora 2',
        step1Description:
            'Перейдите на страницу <span class="highlight-text">"Изображение в видео ИИ"</span>, затем выберите "Sora 2" в раскрывающемся списке моделей.',
        step2Title: 'Введите подробный промпт',
        step2Description:
            'Опишите желаемый результат и выберите предпочтительные настройки видео.',
        step3Title: 'Скачайте свое видео',
        step3Description:
            'Нажмите "Создать", чтобы скачать или поделиться сгенерированным видео.',

        // YouTube
        youtubeTitle: 'Видео на YouTube о модели Sora 2',
        youtubeVideosTitle: 'Видео на YouTube о модели Sora 2',
        youtubeVideoTitle: 'Видео на YouTube о модели Sora 2',

        // X
        xPostsTitle: 'Публикации в X о модели Sora 2',

        // Другие модели
        exploreModelsTitle: 'Исследуйте другие модели',
        veo31Title: 'Генератор видео Google Veo 3.1',
        veo3Title: 'Генератор видео Google Veo 3',
        veo3FastTitle: 'Генератор видео Google Veo 3 Fast',
        klingTitle: 'Генератор видео Kling',
        hailuoTitle: 'Генератор видео Hailuo',
        runwayTitle: 'Генератор видео Runway',
        seedanceTitle: 'Генератор видео Seedance 1.0 Pro',
        wanAITitle: 'Генератор видео Wan AI',

        // FAQ
        faqTitle: 'Часто задаваемые вопросы',

        // CTA
        ctaTitle: 'Готовы начать создавать?',
        ctaSubtitle:
            'Оцените Sora 2 уже сейчас и превратите свои идеи в впечатляющие видео',
        ctaDescription:
            'Оцените Sora 2 уже сейчас и превратите свои идеи в впечатляющие видео',
        ctaButton: 'Попробовать Sora 2 на WeryAI',
        ctaNote: 'Кредитная карта не требуется',
        ctaDisclaimer: 'Кредитная карта не требуется',

        // Воспроизведение видео
        videoNotSupported: 'Ваш браузер не поддерживает воспроизведение видео',
        videoUnsupported: 'Ваш браузер не поддерживает воспроизведение видео',
        videoLoadingError: 'Не удалось загрузить видео',
        videoLoadError: 'Не удалось загрузить видео',
        videoReload: 'Перезагрузить',
        sora2Tip: 'Sora 2 предъявляет строгие требования к крупным планам реальных людей. Рекомендуется загружать фотографии с дальним планом или не в анфас, чтобы повысить вероятность успеха.',
    },
    pt: {
        // Título e descrição da página
        pageTitle:
            'Gerador de vídeos com IA OpenAI Sora-2 - Ferramenta revolucionária de criação de vídeos | WeryAI',
        pageDescription:
            'Experimente o gerador de vídeos com IA Sora-2 da OpenAI com realismo físico, geração de áudio sincronizada, alta consistência e recursos essenciais. Teste gratuitamente na plataforma WeryAI e crie conteúdo de vídeo profissional com IA.',
        pageKeywords:
            'Sora-2, gerador de vídeo com IA OpenAI, criação de vídeo com IA, vídeo de inteligência artificial, ferramenta de geração de vídeo, vídeo com IA grátis, WeryAI, produção de vídeo',

        // Seção do gerador
        generatorTitle: 'Gerador de vídeos OpenAI Sora-2',
        generatorDescription:
            'O WeryAI agora integra profundamente o modelo <span class="text-text-active">Sora 2</span>, uma grande evolução em relação ao Sora original (fevereiro de 2024), com avanços significativos em realismo, precisão física, controle e estilo. O Sora 2 segue as leis da física e mantém o estado do mundo consistente em vários takes. Agora ele está disponível no <span class="text-text-active">gerador de vídeos da WeryAI, clique aqui para testar gratuitamente</span>!',

        // Abas
        tabImageToVideo: 'Imagem para vídeo',
        tabTextToVideo: 'Texto para vídeo',

        // Seção de recursos principais
        coreFeaturesTitle: 'Principais recursos do Sora 2',
        coreFeaturesSubtitle:
            'Explore os recursos centrais do gerador de vídeos com IA OpenAI Sora-2 e embarque em uma jornada revolucionária de criação de vídeos com IA',

        // Realismo físico
        physicalRealismTitle: 'Realismo físico',
        physicalRealismDescription:
            'O Sora-2 simula com precisão gravidade, flutuabilidade, colisões de objetos e outras leis físicas, gerando vídeos com alto realismo físico e deixando suas criações mais naturais.',

        // Áudio sincronizado
        synchronizedAudioTitle: 'Geração de áudio sincronizada',
        synchronizedAudioDescription:
            'Integra a geração de voz, efeitos sonoros ambientais e trilha sonora para oferecer uma experiência audiovisual perfeitamente sincronizada, tornando seus vídeos mais envolventes.',

        // Alta consistência
        highConsistencyTitle: 'Alta consistência e narrativa multissena',
        highConsistencyDescription:
            'Segue fielmente prompts detalhados com múltiplas cenas e mantém a coerência do estado do mundo em diferentes cenários, criando experiências narrativas completas.',

        // Integração de pessoas reais
        realWorldCharacterTitle: 'Integração de pessoas reais',
        realWorldCharacterDescription:
            'Os usuários podem gravar a si mesmos ou outras pessoas e inserir esses registros de forma realista nos vídeos, alcançando efeitos de "participação especial" com permissões de uso e revogação controladas.',

        // Como usar
        howToUseTitle: 'Como usar',
        howToUseSubtitle: 'Comece em três passos simples',
        step1Title: 'Selecione o modelo Sora 2',
        step1Description:
            'Acesse a página <span class="highlight-text">"Imagem para vídeo IA"</span> e escolha "Sora 2" no menu suspenso de modelos.',
        step2Title: 'Insira seu prompt detalhado',
        step2Description:
            'Descreva o que deseja gerar e selecione a configuração de vídeo preferida.',
        step3Title: 'Baixe seu vídeo',
        step3Description:
            'Clique em "Criar" para baixar ou compartilhar o vídeo gerado.',

        // YouTube
        youtubeTitle: 'Vídeos do YouTube sobre o modelo Sora 2',
        youtubeVideosTitle: 'Vídeos do YouTube sobre o modelo Sora 2',
        youtubeVideoTitle: 'Vídeos do YouTube sobre o modelo Sora 2',

        // Postagens no X
        xPostsTitle: 'Publicações no X sobre o modelo Sora 2',

        // Explorar modelos
        exploreModelsTitle: 'Explore outros modelos',
        veo31Title: 'Gerador de vídeo com IA Google Veo 3.1',
        veo3Title: 'Gerador de vídeo com IA Google Veo 3',
        veo3FastTitle: 'Gerador de vídeo com IA Google Veo 3 Fast',
        klingTitle: 'Gerador de vídeo com IA Kling',
        hailuoTitle: 'Gerador de vídeo com IA Hailuo',
        runwayTitle: 'Gerador de vídeo com IA Runway',
        seedanceTitle: 'Gerador de vídeo Seedance 1.0 Pro',
        wanAITitle: 'Gerador de vídeo com IA Wan',

        // FAQ
        faqTitle: 'Perguntas frequentes',

        // CTA
        ctaTitle: 'Pronto para começar a criar?',
        ctaSubtitle:
            'Experimente o Sora 2 agora e transforme sua criatividade em vídeos incríveis',
        ctaDescription:
            'Experimente o Sora 2 agora e transforme sua criatividade em vídeos incríveis',
        ctaButton: 'Teste o Sora 2 na WeryAI',
        ctaNote: 'Não é necessário cartão de crédito',
        ctaDisclaimer: 'Não é necessário cartão de crédito',

        // Reprodução de vídeo
        videoNotSupported: 'Seu navegador não suporta reprodução de vídeo',
        videoUnsupported: 'Seu navegador não suporta reprodução de vídeo',
        videoLoadingError: 'Falha ao carregar o vídeo',
        videoLoadError: 'Falha ao carregar o vídeo',
        videoReload: 'Recarregar',
        sora2Tip: 'O Sora 2 tem uma revisão rigorosa para close-ups de pessoas reais. Recomenda-se o upload de fotos de plano aberto ou não frontais para aumentar a taxa de sucesso.',
    },
    it: {
        // Titolo e descrizione della pagina
        pageTitle:
            'Generatore video IA OpenAI Sora-2 - Strumento rivoluzionario per la creazione video | WeryAI',
        pageDescription:
            "Prova il generatore video IA Sora-2 di OpenAI con realismo fisico, generazione audio sincronizzata, alta coerenza e funzioni chiave. Testalo gratuitamente sulla piattaforma WeryAI e crea contenuti video professionali con l'IA.",
        pageKeywords:
            'Sora-2, generatore video IA OpenAI, creazione video IA, video intelligenza artificiale, strumento generazione video, video IA gratuito, WeryAI, produzione video',

        // Sezione del generatore
        generatorTitle: 'Generatore video OpenAI Sora-2',
        generatorDescription:
            'WeryAI integra ora in profondità il modello <span class="text-text-active">Sora 2</span>, un grande miglioramento rispetto al Sora originale (febbraio 2024), con progressi significativi in realismo, precisione fisica, controllabilità e stile. Sora 2 rispetta le leggi fisiche e mantiene uno stato del mondo coerente attraverso più inquadrature. Ora è disponibile nel <span class="text-text-active">generatore video di WeryAI, clicca qui per provarlo gratis</span>!',

        // Schede
        tabImageToVideo: 'Immagine in video',
        tabTextToVideo: 'Testo in video',

        // Funzioni principali
        coreFeaturesTitle: 'Funzioni principali di Sora 2',
        coreFeaturesSubtitle:
            'Esplora le funzioni chiave del generatore video IA OpenAI Sora-2 e intraprendi un viaggio rivoluzionario nella creazione video con IA',

        // Realismo fisico
        physicalRealismTitle: 'Realismo fisico',
        physicalRealismDescription:
            'Sora-2 simula con precisione gravità, galleggiabilità, collisioni tra oggetti e altre leggi fisiche, generando contenuti video con elevato realismo fisico e rendendo le tue creazioni più naturali.',

        // Audio sincronizzato
        synchronizedAudioTitle: 'Generazione audio sincronizzata',
        synchronizedAudioDescription:
            "Integra generazione di voce, effetti sonori ambientali e musica di sottofondo per offrire un'esperienza audiovisiva perfettamente sincronizzata e rendere i tuoi video più coinvolgenti.",

        // Alta coerenza
        highConsistencyTitle: 'Alta coerenza e narrazione multi-shot',
        highConsistencyDescription:
            'Segue fedelmente prompt dettagliati con più inquadrature e mantiene la coerenza dello stato del mondo tra scene diverse, creando esperienze narrative complete.',

        // Persone reali
        realWorldCharacterTitle: 'Integrazione di persone reali',
        realWorldCharacterDescription:
            'Gli utenti possono registrare se stessi o altre persone e integrare queste immagini in modo realistico nei video, ottenendo effetti "cameo" con permessi di utilizzo e revoca controllabili.',

        // Come usare
        howToUseTitle: 'Come usarlo',
        howToUseSubtitle: 'Inizia in tre semplici passaggi',
        step1Title: 'Seleziona il modello Sora 2',
        step1Description:
            'Vai alla pagina <span class="highlight-text">"Immagine in video IA"</span> e seleziona "Sora 2" dal menu a discesa dei modelli.',
        step2Title: 'Inserisci il tuo prompt dettagliato',
        step2Description:
            'Descrivi ciò che desideri generare e scegli la configurazione video preferita.',
        step3Title: 'Scarica il tuo video',
        step3Description:
            'Fai clic su "Crea" per scaricare o condividere il video generato.',

        // Video YouTube
        youtubeTitle: 'Video YouTube sul modello Sora 2',
        youtubeVideosTitle: 'Video YouTube sul modello Sora 2',
        youtubeVideoTitle: 'Video YouTube sul modello Sora 2',

        // Post su X
        xPostsTitle: 'Post su X sul modello Sora 2',

        // Esplora altri modelli
        exploreModelsTitle: 'Esplora altri modelli',
        veo31Title: 'Generatore video IA Google Veo 3.1',
        veo3Title: 'Generatore video IA Google Veo 3',
        veo3FastTitle: 'Generatore video IA Google Veo 3 Fast',
        klingTitle: 'Generatore video IA Kling',
        hailuoTitle: 'Generatore video IA Hailuo',
        runwayTitle: 'Generatore video IA Runway',
        seedanceTitle: 'Generatore video Seedance 1.0 Pro',
        wanAITitle: 'Generatore video IA Wan',

        // FAQ
        faqTitle: 'Domande frequenti',

        // CTA
        ctaTitle: 'Pronto a iniziare a creare?',
        ctaSubtitle:
            'Prova Sora 2 ora e trasforma la tua creatività in video straordinari',
        ctaDescription:
            'Prova Sora 2 ora e trasforma la tua creatività in video straordinari',
        ctaButton: 'Prova Sora 2 su WeryAI',
        ctaNote: 'Nessuna carta di credito richiesta',
        ctaDisclaimer: 'Nessuna carta di credito richiesta',

        // Riproduzione video
        videoNotSupported: 'Il tuo browser non supporta la riproduzione video',
        videoUnsupported: 'Il tuo browser non supporta la riproduzione video',
        videoLoadingError: 'Caricamento del video non riuscito',
        videoLoadError: 'Caricamento del video non riuscito',
        videoReload: 'Ricarica',
        sora2Tip: 'Sora 2 ha una revisione rigorosa per i primi piani di persone reali. Si consiglia di caricare foto a campo lungo o non frontali per aumentare il tasso di successo.',
    },
    ar: {
        // عنوان ووصف الصفحة
        pageTitle:
            'مولد الفيديو بالذكاء الاصطناعي OpenAI Sora-2 - أداة ثورية لصناعة الفيديو | WeryAI',
        pageDescription:
            'اختبر مولد الفيديو بالذكاء الاصطناعي Sora-2 من OpenAI مع الواقعية الفيزيائية، وتوليد الصوت المتزامن، والاتساق العالي، والميزات الأساسية. جرّبه مجانًا على منصة WeryAI وأنشئ محتوى فيديو احترافيًا بالذكاء الاصطناعي.',
        pageKeywords:
            'Sora-2, مولد فيديو بالذكاء الاصطناعي من OpenAI, إنشاء فيديو بالذكاء الاصطناعي, فيديو ذكاء اصطناعي, أداة توليد الفيديو, فيديو ذكاء اصطناعي مجاني, WeryAI, إنتاج الفيديو',

        // قسم المولد
        generatorTitle: 'مولد الفيديو OpenAI Sora-2',
        generatorDescription:
            'يقوم WeryAI الآن بدمج نموذج <span class="text-text-active">Sora 2</span> بعمق، يلتزم Sora 2 بقوانين الفيزياء ويحافظ على حالة عالم متسقة عبر لقطات متعددة. أصبح متاحًا الآن في <span class="text-text-active">مولد الفيديو من WeryAI، انقر هنا للتجربة المجانية</span>!',

        // علامات التبويب
        tabImageToVideo: 'تحويل صورة إلى فيديو',
        tabTextToVideo: 'تحويل نص إلى فيديو',

        // قسم الميزات الأساسية
        coreFeaturesTitle: 'الميزات الرئيسية لـ Sora 2',
        coreFeaturesSubtitle:
            'استكشف الميزات الأساسية لمولد الفيديو بالذكاء الاصطناعي OpenAI Sora-2 وابدأ رحلة ثورية في إنشاء الفيديو بالذكاء الاصطناعي',

        // الواقعية الفيزيائية
        physicalRealismTitle: 'واقعية فيزيائية',
        physicalRealismDescription:
            'يستطيع Sora-2 محاكاة الجاذبية، والطفو، وتصادم الأجسام، وغيرها من القوانين الفيزيائية بدقة، لينتج محتوى فيديو بواقعية فيزيائية عالية ويجعل أعمالك أكثر طبيعية.',

        // الصوت المتزامن
        synchronizedAudioTitle: 'توليد صوت متزامن',
        synchronizedAudioDescription:
            'يُدمج توليد الصوت، والمؤثرات البيئية، والموسيقى الخلفية لتقديم تجربة سمعية وبصرية متزامنة تمامًا وجعل الفيديوهات أكثر حيوية وجاذبية.',

        // الاتساق العالي
        highConsistencyTitle: 'اتساق عالٍ وسرد متعدد اللقطات',
        highConsistencyDescription:
            'يتبع المطالبات التفصيلية متعددة اللقطات بدقة ويحافظ على تماسك حالة العالم عبر مشاهد مختلفة، مما يخلق تجربة سردية متكاملة.',

        // دمج الشخصيات الحقيقية
        realWorldCharacterTitle: 'دمج شخصيات من العالم الحقيقي',
        realWorldCharacterDescription:
            'يمكن للمستخدمين تسجيل أنفسهم أو الآخرين وإدراج هذه الصور في الفيديو بشكل واقعي، مع إمكانية التحكم في أذونات الاستخدام والإلغاء لتحقيق تأثير "الظهور الخاص".',

        // كيفية الاستخدام
        howToUseTitle: 'كيفية الاستخدام',
        howToUseSubtitle: 'ابدأ بثلاث خطوات بسيطة',
        step1Title: 'اختر نموذج Sora 2',
        step1Description:
            'انتقل إلى صفحة <span class="highlight-text">"صورة إلى فيديو بالذكاء الاصطناعي"</span> ثم اختر "Sora 2" من قائمة النماذج المنسدلة.',
        step2Title: 'أدخل المطالبة التفصيلية',
        step2Description:
            'صف المحتوى الذي تريد إنشاءه واختر إعدادات الفيديو المفضلة لديك.',
        step3Title: 'حمّل الفيديو الخاص بك',
        step3Description:
            'انقر على "إنشاء" لتحميل أو مشاركة الفيديو الذي تم إنشاؤه.',

        // مقاطع YouTube
        youtubeTitle: 'مقاطع YouTube عن نموذج الفيديو Sora 2',
        youtubeVideosTitle: 'مقاطع YouTube عن نموذج الفيديو Sora 2',
        youtubeVideoTitle: 'مقاطع YouTube عن نموذج الفيديو Sora 2',

        // منشورات X
        xPostsTitle: 'منشورات X عن نموذج الفيديو Sora 2',

        // استكشاف نماذج أخرى
        exploreModelsTitle: 'استكشف نماذج أخرى',
        veo31Title: 'مولد الفيديو Google Veo 3.1 بالذكاء الاصطناعي',
        veo3Title: 'مولد الفيديو Google Veo 3 بالذكاء الاصطناعي',
        veo3FastTitle: 'مولد الفيديو Google Veo 3 Fast بالذكاء الاصطناعي',
        klingTitle: 'مولد الفيديو Kling بالذكاء الاصطناعي',
        hailuoTitle: 'مولد الفيديو Hailuo بالذكاء الاصطناعي',
        runwayTitle: 'مولد الفيديو Runway بالذكاء الاصطناعي',
        seedanceTitle: 'مولد الفيديو Seedance 1.0 Pro',
        wanAITitle: 'مولد الفيديو Wan بالذكاء الاصطناعي',

        // الأسئلة الشائعة
        faqTitle: 'الأسئلة الشائعة',

        // دعوة لاتخاذ إجراء
        ctaTitle: 'هل أنت مستعد للبدء في الإبداع؟',
        ctaSubtitle: 'جرّب Sora 2 الآن وحوّل أفكارك إلى فيديوهات مذهلة',
        ctaDescription: 'جرّب Sora 2 الآن وحوّل أفكارك إلى فيديوهات مذهلة',
        ctaButton: 'جرّب Sora 2 على WeryAI',
        ctaNote: 'لا حاجة إلى بطاقة ائتمان',
        ctaDisclaimer: 'لا حاجة إلى بطاقة ائتمان',

        // تشغيل الفيديو
        videoNotSupported: 'المتصفح الخاص بك لا يدعم تشغيل الفيديو',
        videoUnsupported: 'المتصفح الخاص بك لا يدعم تشغيل الفيديو',
        videoLoadingError: 'فشل تحميل الفيديو',
        videoLoadError: 'فشل تحميل الفيديو',
        videoReload: 'إعادة التحميل',
        sora2Tip: 'يخضع Sora 2 لمراجعة صارمة للقطات القريبة للأشخاص الحقيقيين. يُنصح بتحميل صور بعيدة أو غير أمامية لتحسين معدل النجاح.',
        },
    th: {
        // หัวข้อและคำอธิบายหน้า
        pageTitle: 'OpenAI Sora 2 | เครื่องมือสร้างวิดีโอ AI ระดับปฏิวัติ',
        pageDescription:
            'สัมผัส OpenAI Sora-2 ด้วยความสมจริงทางฟิสิกส์ การสร้างเสียงซิงก์ และความสอดคล้องสูง ทดลองฟรีบน WeryAI และสร้างวิดีโอ AI ระดับมืออาชีพ',
        pageKeywords:
            'Sora-2, เครื่องมือสร้างวิดีโอ AI ของ OpenAI, การสร้างวิดีโอ AI, วิดีโอปัญญาประดิษฐ์, เครื่องมือสร้างวิดีโอ, วิดีโอ AI ฟรี, WeryAI, การผลิตวิดีโอ',

        // ส่วนของเครื่องมือสร้าง
        generatorTitle: 'เครื่องมือสร้างวิดีโอ OpenAI Sora 2',
        generatorDescription:
            'ขณะนี้ WeryAI ได้ผสานรวมโมเดล <span class="text-text-active">Sora 2</span> อย่างลึกซึ้งแล้ว ขณะนี้ WeryAI ได้ผสานรวมโมเดล <span class="text-text-active">Sora 2</span> อย่างลึกซึ้งแล้ว พ. 2024) อย่างมากในด้านความสมจริง ความแม่นยำทางฟิสิกส์ การควบคุม และสไตล์ Sora 2 ทำตามกฎฟิสิกส์และรักษาความสอดคล้องของโลกได้หลายช็อต ตอนนี้ใช้งานได้ใน <span class="text-text-active">เครื่องมือสร้างวิดีโอ WeryAI คลิกเพื่อทดลองฟรี</span>!',

        // แท็บ
        tabImageToVideo: 'ภาพเป็นวิดีโอ',
        tabTextToVideo: 'ข้อความเป็นวิดีโอ',

        // ฟีเจอร์หลัก
        coreFeaturesTitle: 'ฟีเจอร์หลักของ Sora 2',
        coreFeaturesSubtitle:
            'สำรวจฟีเจอร์หลักของเครื่องมือสร้างวิดีโอ AI OpenAI Sora-2 และเริ่มต้นการสร้างวิดีโอ AI แบบปฏิวัติ',

        // ความสมจริงทางกายภาพ
        physicalRealismTitle: 'ความสมจริงทางกายภาพ',
        physicalRealismDescription:
            'Sora-2 จำลองแรงโน้มถ่วง แรงลอยตัว การชนวัตถุ และกฎฟิสิกส์อื่น ๆ ได้อย่างแม่นยำ สร้างวิดีโอที่สมจริงสูงและดูเป็นธรรมชาติ',

        // การสร้างเสียงซิงก์
        synchronizedAudioTitle: 'การสร้างเสียงซิงก์',
        synchronizedAudioDescription:
            'ผสานการสร้างเสียงพูด เอฟเฟกต์เสียงแวดล้อม และดนตรีพื้นหลัง ให้ซิงก์ภาพ-เสียงอย่างสมบูรณ์ ทำให้วิดีโอมีชีวิตชีวาและน่าดึงดูด',

        // ความสอดคล้องสูง
        highConsistencyTitle: 'ความสอดคล้องสูงและการเล่าเรื่องหลายช็อต',
        highConsistencyDescription:
            'ทำตามพรอมต์หลายช็อตอย่างแม่นยำ และคงสถานะโลกให้สอดคล้องกันข้ามฉาก สร้างประสบการณ์การเล่าเรื่องที่ครบถ้วน',

        // การผสานตัวละครโลกจริง
        realWorldCharacterTitle: 'การผสานตัวละครโลกจริง',
        realWorldCharacterDescription:
            'ผู้ใช้สามารถบันทึกภาพของตนเองหรือผู้อื่น และผสานลงในวิดีโออย่างสมจริง พร้อมเอฟเฟกต์แบบ "cameo" และสิทธิ์การใช้งานที่ควบคุมและเพิกถอนได้',

        // วิธีใช้งาน
        howToUseTitle: 'วิธีใช้งาน',
        howToUseSubtitle: '3 ขั้นตอนง่าย ๆ เริ่มต้นได้ทันที',
        step1Title: 'เลือกโมเดล Sora 2',
        step1Description:
            'ไปที่หน้า <span class="highlight-text">"AI ภาพเป็นวิดีโอ"</span> แล้วเลือก "Sora 2" ในเมนูโมเดล',
        step2Title: 'พิมพ์พรอมต์แบบละเอียด',
        step2Description:
            'อธิบายสิ่งที่ต้องการสร้างและเลือกการตั้งค่าวิดีโอที่ต้องการ',
        step3Title: 'ดาวน์โหลดวิดีโอ',
        step3Description:
            'คลิก "สร้าง" เพื่อดาวน์โหลดหรือแชร์วิดีโอที่สร้างขึ้น',

        // วิดีโอ YouTube
        youtubeTitle: 'วิดีโอ YouTube เกี่ยวกับโมเดลวิดีโอ Sora 2',
        youtubeVideosTitle: 'วิดีโอ YouTube เกี่ยวกับโมเดลวิดีโอ Sora 2',
        youtubeVideoTitle: 'วิดีโอ YouTube เกี่ยวกับโมเดลวิดีโอ Sora 2',

        // โพสต์บน X
        xPostsTitle: 'โพสต์บน X เกี่ยวกับโมเดลวิดีโอ Sora 2',

        // สำรวจโมเดลอื่น ๆ
        exploreModelsTitle: 'สำรวจโมเดลอื่น ๆ',
        veo31Title: 'เครื่องมือสร้างวิดีโอ AI Google Veo 3.1',
        veo3Title: 'เครื่องมือสร้างวิดีโอ AI Google Veo 3',
        veo3FastTitle: 'เครื่องมือสร้างวิดีโอ AI Google Veo 3 Fast',
        klingTitle: 'เครื่องมือสร้างวิดีโอ AI Kling',
        hailuoTitle: 'เครื่องมือสร้างวิดีโอ AI Hailuo',
        runwayTitle: 'เครื่องมือสร้างวิดีโอ AI Runway',
        seedanceTitle: 'เครื่องมือสร้างวิดีโอ Seedance 1.0 Pro',
        wanAITitle: 'เครื่องมือสร้างวิดีโอ Wan AI',

        // คำถามที่พบบ่อย
        faqTitle: 'คำถามที่พบบ่อย',

        // ส่วน CTA
        ctaTitle: 'พร้อมเริ่มสร้างแล้วหรือยัง?',
        ctaSubtitle:
            'ลอง Sora 2 ตอนนี้และเปลี่ยนความคิดสร้างสรรค์เป็นวิดีโอสุดว้าว',
        ctaDescription:
            'ลอง Sora 2 ตอนนี้และเปลี่ยนความคิดสร้างสรรค์เป็นวิดีโอสุดว้าว',
        ctaButton: 'ลอง Sora 2 บน WeryAI',
        ctaNote: 'ไม่ต้องใช้บัตรเครดิต',
        ctaDisclaimer: 'ไม่ต้องใช้บัตรเครดิต',

        // การเล่นวิดีโอ
        videoNotSupported: 'เบราว์เซอร์ของคุณไม่รองรับการเล่นวิดีโอ',
        videoUnsupported: 'เบราว์เซอร์ของคุณไม่รองรับการเล่นวิดีโอ',
        videoLoadingError: 'โหลดวิดีโอล้มเหลว',
        videoLoadError: 'โหลดวิดีโอล้มเหลว',
        videoReload: 'โหลดใหม่',
        sora2Tip: 'Sora 2 มีการตรวจสอบเข้มงวดสำหรับภาพระยะใกล้ของบุคคลจริง แนะนำให้อัปโหลดภาพระยะไกลหรือไม่ใช่มุมตรงเพื่อเพิ่มอัตราความสำเร็จ',
        },
    da: {
        // Sidetitel og beskrivelse
        pageTitle:
            'OpenAI Sora-2 AI-videogenerator – revolutionerende værktøj til AI-video',
        pageDescription:
            'Oplev OpenAI Sora-2 med fysisk realisme, synkron lydgenerering, høj konsistens og kernefunktioner. Prøv gratis på WeryAI og skab professionelt AI-videoindhold.',
        pageKeywords:
            'Sora-2, OpenAI AI-videogenerator, AI-videoskabelse, kunstig intelligens video, videogenereringsværktøj, gratis AI-video, WeryAI, videoproduktion',

        // Generatorafsnit
        generatorTitle: 'OpenAI Sora-2 videogenerator',
        generatorDescription:
            'WeryAI har nu integreret modellen <span class="text-text-active">Sora 2</span> i dybden, en stor forbedring af den oprindelige Sora (februar 2024) med markante fremskridt i realisme, fysisk nøjagtighed, kontrol og stil. Sora 2 kan følge fysiske love og bevare en konsistent verdens-tilstand på tværs af flere shots. Den er nu tilgængelig i <span class="text-text-active">WeryAI-videogeneratoren – klik her for at prøve gratis</span>!',

        // Faner
        tabImageToVideo: 'Billede til video',
        tabTextToVideo: 'Tekst til video',

        // Kernefunktioner
        coreFeaturesTitle: 'Sora 2s vigtigste funktioner',
        coreFeaturesSubtitle:
            'Udforsk kernefunktionerne i OpenAI Sora-2 AI-videogenerator og start en revolutionerende rejse i AI-videoskabelse',

        // Fysisk realisme
        physicalRealismTitle: 'Fysisk realisme',
        physicalRealismDescription:
            'Sora-2 simulerer præcist tyngdekraft, opdrift, kollisioner og andre fysiske love og skaber videoer med høj fysisk realisme, så dine kreationer virker mere naturlige.',

        // Synkron lyd
        synchronizedAudioTitle: 'Synkron lydgenerering',
        synchronizedAudioDescription:
            'Integrerer tale, miljølydeffekter og baggrundsmusik for perfekt lyd-billedsynk, så videoer bliver mere levende og engagerende.',

        // Høj konsistens
        highConsistencyTitle: 'Høj konsistens og multi-shot-fortælling',
        highConsistencyDescription:
            'Følger detaljerede multi-shot-prompts meget trofast og bevarer verdens-tilstanden på tværs af scener for en fuld fortælleoplevelse.',

        // Integration af personer
        realWorldCharacterTitle: 'Integration af virkelige personer',
        realWorldCharacterDescription:
            'Brugere kan optage billeder af sig selv eller andre og integrere dem realistisk i videoer, med "cameo"-effekter og kontrollerbar brug/tilbagekaldelse.',

        // Sådan bruges
        howToUseTitle: 'Sådan bruger du',
        howToUseSubtitle: 'Tre enkle trin for at komme i gang',
        step1Title: 'Vælg Sora 2-modellen',
        step1Description:
            'Gå til <span class="highlight-text">"Billede til video AI"</span>-siden og vælg "Sora 2" i modelmenuen.',
        step2Title: 'Indtast din detaljerede prompt',
        step2Description:
            'Beskriv, hvad du vil generere, og vælg din foretrukne videokonfiguration.',
        step3Title: 'Download din video',
        step3Description:
            'Klik "Opret" for at downloade eller dele din genererede video.',

        // YouTube-videoer
        youtubeTitle: 'YouTube-videoer om Sora 2-videomodellen',
        youtubeVideosTitle: 'YouTube-videoer om Sora 2-videomodellen',
        youtubeVideoTitle: 'YouTube-videoer om Sora 2-videomodellen',

        // X-opslag
        xPostsTitle: 'X-opslag om Sora 2-videomodellen',

        // Udforsk andre modeller
        exploreModelsTitle: 'Udforsk andre modeller',
        veo31Title: 'Google Veo 3.1 AI-videogenerator',
        veo3Title: 'Google Veo 3 AI-videogenerator',
        veo3FastTitle: 'Google Veo 3 Fast AI-videogenerator',
        klingTitle: 'Kling AI-videogenerator',
        hailuoTitle: 'Hailuo AI-videogenerator',
        runwayTitle: 'Runway AI-videogenerator',
        seedanceTitle: 'Seedance 1.0 Pro videogenerator',
        wanAITitle: 'Wan AI-videogenerator',

        // FAQ
        faqTitle: 'Ofte stillede spørgsmål',

        // CTA
        ctaTitle: 'Klar til at komme i gang?',
        ctaSubtitle:
            'Prøv Sora 2 nu og forvandl din kreativitet til fantastiske videoer',
        ctaDescription:
            'Prøv Sora 2 nu og forvandl din kreativitet til fantastiske videoer',
        ctaButton: 'Prøv Sora 2 på WeryAI',
        ctaNote: 'Intet kreditkort kræves',
        ctaDisclaimer: 'Intet kreditkort kræves',

        // Videoafspilning
        videoNotSupported: 'Din browser understøtter ikke videoafspilning',
        videoUnsupported: 'Din browser understøtter ikke videoafspilning',
        videoLoadingError: 'Videoen kunne ikke indlæses',
        videoLoadError: 'Videoen kunne ikke indlæses',
        videoReload: 'Genindlæs',
        sora2Tip: 'Sora 2 har streng kontrol af nærbilleder af rigtige personer. Det anbefales at uploade totalbilleder eller ikke-frontale billeder for at øge succesraten.',
        },
    no: {
        // Sidetittel og beskrivelse
        pageTitle:
            'OpenAI Sora-2 AI-videogenerator – revolusjonerende verktøy for AI-video',
        pageDescription:
            'Opplev OpenAI Sora-2 med fysisk realisme, synkron lydgenerering, høy konsistens og kjernefunksjoner. Prøv gratis på WeryAI og lag profesjonelt AI-videoinnhold.',
        pageKeywords:
            'Sora-2, OpenAI AI-videogenerator, AI-videoskaping, kunstig intelligens video, videogenereringsverktøy, gratis AI-video, WeryAI, videoproduksjon',

        // Generatorseksjon
        generatorTitle: 'OpenAI Sora-2 videogenerator',
        generatorDescription:
            'WeryAI har nå integrert modellen <span class="text-text-active">Sora 2</span> i dybden, en stor forbedring fra den opprinnelige Sora (februar 2024), med betydelige fremskritt i realisme, fysisk nøyaktighet, kontroll og stil. Sora 2 kan følge fysiske lover og holde verdens-tilstanden konsistent på tvers av flere shots. Nå tilgjengelig i <span class="text-text-active">WeryAI-videogeneratoren – klikk her for å prøve gratis</span>!',

        // Faner
        tabImageToVideo: 'Bilde til video',
        tabTextToVideo: 'Tekst til video',

        // Kjernefunksjoner
        coreFeaturesTitle: 'Sora 2s hovedfunksjoner',
        coreFeaturesSubtitle:
            'Utforsk kjernefunksjonene i OpenAI Sora-2 AI-videogenerator og start en revolusjonerende AI-videoskaping',

        // Fysisk realisme
        physicalRealismTitle: 'Fysisk realisme',
        physicalRealismDescription:
            'Sora-2 kan nøyaktig simulere tyngdekraft, oppdrift, kollisjoner og andre fysiske lover og lage videoer med høy fysisk realisme som gjør innholdet mer naturlig.',

        // Synkron lyd
        synchronizedAudioTitle: 'Synkron lydgenerering',
        synchronizedAudioDescription:
            'Integrerer tale, miljølydeffekter og bakgrunnsmusikk for perfekt lyd-bildesynk, som gjør videoene mer levende og engasjerende.',

        // Høy konsistens
        highConsistencyTitle: 'Høy konsistens og multi-shot-fortelling',
        highConsistencyDescription:
            'Følger detaljerte multi-shot-prompter svært trofast og holder verdens-tilstanden konsistent på tvers av scener for en helhetlig fortelling.',

        // Integrering av personer
        realWorldCharacterTitle: 'Integrering av ekte personer',
        realWorldCharacterDescription:
            'Brukere kan ta opp seg selv eller andre og realistisk integrere dem i videoer, med "cameo"-effekter og kontrollerbar bruk/tilbakekalling.',

        // Slik bruker du
        howToUseTitle: 'Slik bruker du',
        howToUseSubtitle: 'Tre enkle trinn for å komme i gang',
        step1Title: 'Velg Sora 2-modell',
        step1Description:
            'Gå til <span class="highlight-text">"Bilde til video AI"</span>-siden og velg "Sora 2" i modellmenyen.',
        step2Title: 'Skriv inn en detaljert prompt',
        step2Description:
            'Beskriv hva du vil generere og velg ønsket videokonfigurasjon.',
        step3Title: 'Last ned videoen din',
        step3Description:
            'Klikk "Opprett" for å laste ned eller dele videoen du har laget.',

        // YouTube-videoer
        youtubeTitle: 'YouTube-videoer om Sora 2-videomodellen',
        youtubeVideosTitle: 'YouTube-videoer om Sora 2-videomodellen',
        youtubeVideoTitle: 'YouTube-videoer om Sora 2-videomodellen',

        // X-innlegg
        xPostsTitle: 'X-innlegg om Sora 2-videomodellen',

        // Utforsk andre modeller
        exploreModelsTitle: 'Utforsk andre modeller',
        veo31Title: 'Google Veo 3.1 AI-videogenerator',
        veo3Title: 'Google Veo 3 AI-videogenerator',
        veo3FastTitle: 'Google Veo 3 Fast AI-videogenerator',
        klingTitle: 'Kling AI-videogenerator',
        hailuoTitle: 'Hailuo AI-videogenerator',
        runwayTitle: 'Runway AI-videogenerator',
        seedanceTitle: 'Seedance 1.0 Pro videogenerator',
        wanAITitle: 'Wan AI-videogenerator',

        // FAQ
        faqTitle: 'Ofte stilte spørsmål',

        // CTA
        ctaTitle: 'Klar til å komme i gang?',
        ctaSubtitle:
            'Prøv Sora 2 nå og gjør kreativiteten din om til fantastiske videoer',
        ctaDescription:
            'Prøv Sora 2 nå og gjør kreativiteten din om til fantastiske videoer',
        ctaButton: 'Prøv Sora 2 på WeryAI',
        ctaNote: 'Ingen kredittkort nødvendig',
        ctaDisclaimer: 'Ingen kredittkort nødvendig',

        // Videoavspilling
        videoNotSupported: 'Nettleseren din støtter ikke videoavspilling',
        videoUnsupported: 'Nettleseren din støtter ikke videoavspilling',
        videoLoadingError: 'Videoen kunne ikke lastes inn',
        videoLoadError: 'Videoen kunne ikke lastes inn',
        videoReload: 'Last inn på nytt',
        sora2Tip: 'Sora 2 har streng kontroll av nærbilder av ekte personer. Det anbefales å laste opp totalbilder eller ikke-frontale bilder for å øke suksessraten.',
        },
    nl: {
        // Paginatitel en beschrijving
        pageTitle:
            'OpenAI Sora-2 AI-videogenerator – revolutionaire tool voor AI-video',
        pageDescription:
            'Ervaar OpenAI Sora-2 met fysiek realisme, gesynchroniseerde audiogeneratie, hoge consistentie en kernfuncties. Probeer gratis op WeryAI en maak professionele AI-videocontent.',
        pageKeywords:
            'Sora-2, OpenAI AI-videogenerator, AI-videocreatie, kunstmatige intelligentie video, videogeneratietool, gratis AI-video, WeryAI, videoproductie',

        // Generatorsectie
        generatorTitle: 'OpenAI Sora-2 videogenerator',
        generatorDescription:
            'WeryAI heeft het model <span class="text-text-active">Sora 2</span> nu diep geïntegreerd, een grote verbetering ten opzichte van de originele Sora (februari 2024), met flinke vooruitgang in realisme, fysieke nauwkeurigheid, controleerbaarheid en stijl. Sora 2 kan natuurwetten volgen en een consistente wereldtoestand behouden over meerdere shots. Nu beschikbaar in <span class="text-text-active">de WeryAI-videogenerator – klik hier om gratis te proberen</span>!',

        // Tabs
        tabImageToVideo: 'Afbeelding naar video',
        tabTextToVideo: 'Tekst naar video',

        // Kernfuncties
        coreFeaturesTitle: 'Belangrijkste functies van Sora 2',
        coreFeaturesSubtitle:
            'Ontdek de kernfuncties van OpenAI Sora-2 en start een revolutionaire AI-videocreatiereis',

        // Fysiek realisme
        physicalRealismTitle: 'Fysiek realisme',
        physicalRealismDescription:
            'Sora-2 simuleert zwaartekracht, drijfvermogen, botsingen en andere natuurwetten nauwkeurig en genereert video’s met hoog fysiek realisme, waardoor je creaties natuurlijker ogen.',

        // Gesynchroniseerde audio
        synchronizedAudioTitle: 'Gesynchroniseerde audiogeneratie',
        synchronizedAudioDescription:
            'Integreert stem, omgevingsgeluiden en achtergrondmuziek voor perfecte audio-visuele synchronisatie, waardoor video’s levendiger en aantrekkelijker worden.',

        // Hoge consistentie
        highConsistencyTitle: 'Hoge consistentie en multi-shot narratief',
        highConsistencyDescription:
            'Volgt gedetailleerde multi-shot prompts zeer trouw en behoudt wereldconsistentie tussen scènes voor een complete verhaallijn.',

        // Integratie van echte personen
        realWorldCharacterTitle: 'Integratie van echte personen',
        realWorldCharacterDescription:
            'Gebruikers kunnen beelden van zichzelf of anderen opnemen en realistisch integreren in video’s, met "cameo"-effecten en controleerbare gebruiks- en intrekkingsrechten.',

        // Zo gebruik je het
        howToUseTitle: 'Zo gebruik je het',
        howToUseSubtitle: 'Drie eenvoudige stappen om te starten',
        step1Title: 'Selecteer het Sora 2-model',
        step1Description:
            'Ga naar de <span class="highlight-text">"Afbeelding naar video AI"</span>-pagina en kies "Sora 2" in het modelmenu.',
        step2Title: 'Voer je gedetailleerde prompt in',
        step2Description:
            'Beschrijf wat je wilt genereren en kies je gewenste videoconfiguratie.',
        step3Title: 'Download je video',
        step3Description:
            'Klik op "Maken" om je gegenereerde video te downloaden of te delen.',

        // YouTube-video’s
        youtubeTitle: 'YouTube-video’s over het Sora 2-videomodel',
        youtubeVideosTitle: 'YouTube-video’s over het Sora 2-videomodel',
        youtubeVideoTitle: 'YouTube-video’s over het Sora 2-videomodel',

        // X-berichten
        xPostsTitle: 'X-berichten over het Sora 2-videomodel',

        // Andere modellen
        exploreModelsTitle: 'Ontdek andere modellen',
        veo31Title: 'Google Veo 3.1 AI-videogenerator',
        veo3Title: 'Google Veo 3 AI-videogenerator',
        veo3FastTitle: 'Google Veo 3 Fast AI-videogenerator',
        klingTitle: 'Kling AI-videogenerator',
        hailuoTitle: 'Hailuo AI-videogenerator',
        runwayTitle: 'Runway AI-videogenerator',
        seedanceTitle: 'Seedance 1.0 Pro videogenerator',
        wanAITitle: 'Wan AI-videogenerator',

        // Veelgestelde vragen
        faqTitle: 'Veelgestelde vragen',

        // CTA
        ctaTitle: 'Klaar om te starten?',
        ctaSubtitle:
            'Probeer Sora 2 nu en zet je creativiteit om in geweldige video\'s',
        ctaDescription:
            'Probeer Sora 2 nu en zet je creativiteit om in geweldige video\'s',
        ctaButton: 'Probeer Sora 2 op WeryAI',
        ctaNote: 'Geen creditcard vereist',
        ctaDisclaimer: 'Geen creditcard vereist',

        // Video-afspeling
        videoNotSupported: 'Je browser ondersteunt geen video-afspeling',
        videoUnsupported: 'Je browser ondersteunt geen video-afspeling',
        videoLoadingError: 'Video laden mislukt',
        videoLoadError: 'Video laden mislukt',
        videoReload: 'Opnieuw laden',
        sora2Tip: 'Sora 2 beoordeelt close-ups van echte personen streng. Upload bij voorkeur wijde shots of niet-frontale foto\'s om de slagingskans te verhogen.',
        },
    id: {
        // Judul dan deskripsi halaman
        pageTitle:
            'OpenAI Sora-2 AI Video Generator - Alat Revolusioner Pembuatan Video AI',
        pageDescription:
            'Rasakan OpenAI Sora-2 dengan realisme fisik, generasi audio tersinkron, konsistensi tinggi, dan fitur inti. Coba gratis di WeryAI dan buat konten video AI profesional.',
        pageKeywords:
            'Sora-2, generator video AI OpenAI, pembuatan video AI, video kecerdasan buatan, alat generasi video, video AI gratis, WeryAI, produksi video',

        // Bagian generator
        generatorTitle: 'Generator Video OpenAI Sora-2',
        generatorDescription:
            'WeryAI kini telah mengintegrasikan model <span class="text-text-active">Sora 2</span> secara mendalam, peningkatan besar dari Sora asli (Februari 2024) dengan kemajuan signifikan pada realisme, akurasi fisik, kontrol, dan gaya. Sora 2 dapat mengikuti hukum fisika dan menjaga konsistensi dunia di berbagai shot. Kini tersedia di <span class="text-text-active">generator video WeryAI — klik di sini untuk mencoba gratis</span>!',

        // Tab
        tabImageToVideo: 'Gambar ke Video',
        tabTextToVideo: 'Teks ke Video',

        // Fitur inti
        coreFeaturesTitle: 'Fitur Utama Sora 2',
        coreFeaturesSubtitle:
            'Jelajahi fitur inti generator video AI OpenAI Sora-2 dan mulai perjalanan pembuatan video AI yang revolusioner',

        // Realisme fisik
        physicalRealismTitle: 'Realisme Fisik',
        physicalRealismDescription:
            'Sora-2 mensimulasikan gravitasi, daya apung, tabrakan objek, dan hukum fisika lainnya secara akurat, menghasilkan video dengan realisme fisik tinggi sehingga terlihat lebih alami.',

        // Audio tersinkron
        synchronizedAudioTitle: 'Generasi Audio Tersinkron',
        synchronizedAudioDescription:
            'Mengintegrasikan suara, efek suara lingkungan, dan musik latar untuk sinkronisasi audio-visual yang sempurna sehingga video lebih hidup dan menarik.',

        // Konsistensi tinggi
        highConsistencyTitle: 'Konsistensi Tinggi dan Narasi Multi-shot',
        highConsistencyDescription:
            'Mengikuti prompt multi-shot yang detail dengan sangat setia dan menjaga koherensi dunia di berbagai scene untuk pengalaman naratif yang utuh.',

        // Integrasi karakter dunia nyata
        realWorldCharacterTitle: 'Integrasi Karakter Dunia Nyata',
        realWorldCharacterDescription:
            'Pengguna dapat merekam gambar diri sendiri atau orang lain dan mengintegrasikannya secara realistis ke dalam video, menghasilkan efek "cameo" dengan izin penggunaan dan pencabutan yang dapat dikendalikan.',

        // Cara menggunakan
        howToUseTitle: 'Cara Menggunakan',
        howToUseSubtitle: 'Tiga langkah sederhana untuk mulai',
        step1Title: 'Pilih Model Sora 2',
        step1Description:
            'Masuk ke halaman <span class="highlight-text">"Gambar ke Video AI"</span>, lalu pilih "Sora 2" di menu model.',
        step2Title: 'Masukkan Prompt Detail Anda',
        step2Description:
            'Jelaskan apa yang ingin Anda hasilkan dan pilih konfigurasi video yang diinginkan.',
        step3Title: 'Unduh Video Anda',
        step3Description:
            'Klik "Buat" untuk mengunduh atau membagikan video yang dihasilkan.',

        // Video YouTube
        youtubeTitle: 'Video YouTube tentang Model Video Sora 2',
        youtubeVideosTitle: 'Video YouTube tentang Model Video Sora 2',
        youtubeVideoTitle: 'Video YouTube tentang Model Video Sora 2',

        // Postingan X
        xPostsTitle: 'Posting X tentang Model Video Sora 2',

        // Jelajahi model lain
        exploreModelsTitle: 'Jelajahi Model Lain',
        veo31Title: 'Generator Video AI Google Veo 3.1',
        veo3Title: 'Generator Video AI Google Veo 3',
        veo3FastTitle: 'Generator Video AI Google Veo 3 Fast',
        klingTitle: 'Generator Video AI Kling',
        hailuoTitle: 'Generator Video AI Hailuo',
        runwayTitle: 'Generator Video AI Runway',
        seedanceTitle: 'Generator Video Seedance 1.0 Pro',
        wanAITitle: 'Generator Video Wan AI',

        // FAQ
        faqTitle: 'Pertanyaan yang Sering Diajukan',

        // CTA
        ctaTitle: 'Siap mulai berkarya?',
        ctaSubtitle:
            'Coba Sora 2 sekarang dan ubah kreativitas Anda menjadi video yang menakjubkan',
        ctaDescription:
            'Coba Sora 2 sekarang dan ubah kreativitas Anda menjadi video yang menakjubkan',
        ctaButton: 'Coba Sora 2 di WeryAI',
        ctaNote: 'Tidak perlu kartu kredit',
        ctaDisclaimer: 'Tidak perlu kartu kredit',

        // Pemutaran video
        videoNotSupported: 'Browser Anda tidak mendukung pemutaran video',
        videoUnsupported: 'Browser Anda tidak mendukung pemutaran video',
        videoLoadingError: 'Gagal memuat video',
        videoLoadError: 'Gagal memuat video',
        videoReload: 'Muat ulang',
        sora2Tip: 'Sora 2 memiliki peninjauan ketat untuk close-up orang nyata. Disarankan mengunggah foto jarak jauh atau non-frontal untuk meningkatkan tingkat keberhasilan.',
        },
    tr: {
        // Sayfa başlığı ve açıklama
        pageTitle:
            'OpenAI Sora-2 AI Video Üretici – Devrimsel AI Video Aracı',
        pageDescription:
            'Fiziksel gerçekçilik, senkron ses üretimi, yüksek tutarlılık ve temel özellikleriyle OpenAI Sora-2’yi deneyin. WeryAI’de ücretsiz deneyin ve profesyonel AI video içerikleri oluşturun.',
        pageKeywords:
            'Sora-2, OpenAI AI video üretici, AI video oluşturma, yapay zeka video, video üretim aracı, ücretsiz AI video, WeryAI, video prodüksiyon',

        // Üretici bölümü
        generatorTitle: 'OpenAI Sora-2 Video Üretici',
        generatorDescription:
            'WeryAI artık <span class="text-text-active">Sora 2</span> modelini derinlemesine entegre ediyor, orijinal Sora’ya (Şubat 2024) göre gerçekçilik, fiziksel doğruluk, kontrol ve stilde büyük ilerlemeler sunuyor. Sora 2 fizik yasalarını takip eder ve çoklu shot’lar boyunca tutarlı bir dünya durumu korur. Şimdi <span class="text-text-active">WeryAI video üreticide – ücretsiz denemek için tıklayın</span>!',

        // Sekmeler
        tabImageToVideo: 'Görselden Videoya',
        tabTextToVideo: 'Metinden Videoya',

        // Temel özellikler
        coreFeaturesTitle: 'Sora 2 Temel Özellikleri',
        coreFeaturesSubtitle:
            'OpenAI Sora-2 AI video üreticisinin temel özelliklerini keşfedin ve devrimsel bir AI video üretim yolculuğuna çıkın',

        // Fiziksel gerçekçilik
        physicalRealismTitle: 'Fiziksel Gerçekçilik',
        physicalRealismDescription:
            'Sora-2, yerçekimi, kaldırma kuvveti, nesne çarpışmaları ve diğer fizik yasalarını doğru biçimde simüle edebilir; yüksek fiziksel gerçekçilikle içerik üretir.',

        // Senkron ses
        synchronizedAudioTitle: 'Senkron Ses Üretimi',
        synchronizedAudioDescription:
            'Ses, çevresel efektler ve arka plan müziği üretimini entegre ederek kusursuz ses-görüntü senkronu sağlar; videoları daha canlı ve etkileyici kılar.',

        // Yüksek tutarlılık
        highConsistencyTitle: 'Yüksek Tutarlılık ve Çoklu Shot Anlatı',
        highConsistencyDescription:
            'Detaylı çoklu shot promptlarını yüksek doğrulukla takip eder ve sahneler arasında dünya durumunu tutarlı tutarak tam bir anlatı deneyimi oluşturur.',

        // Gerçek dünya karakterleri
        realWorldCharacterTitle: 'Gerçek Dünya Karakter Entegrasyonu',
        realWorldCharacterDescription:
            'Kullanıcılar kendilerinin veya başkalarının görüntülerini kaydedip videolara gerçekçi biçimde entegre edebilir; kontrol edilebilir kullanım ve iptal izinleriyle “cameo” etkisi sağlar.',

        // Nasıl kullanılır
        howToUseTitle: 'Nasıl Kullanılır',
        howToUseSubtitle: 'Başlamak için üç basit adım',
        step1Title: 'Sora 2 Modelini Seçin',
        step1Description:
            '<span class="highlight-text">"Görselden Videoya AI"</span> sayfasına gidin ve model menüsünde "Sora 2"yi seçin.',
        step2Title: 'Detaylı Promptunuzu Girin',
        step2Description:
            'Ne üretmek istediğinizi açıklayın ve tercih ettiğiniz video yapılandırmasını seçin.',
        step3Title: 'Videonuzu İndirin',
        step3Description:
            '“Oluştur”a tıklayarak videonuzu indirin veya paylaşın.',

        // YouTube videoları
        youtubeTitle: 'Sora 2 Video Modeli Hakkında YouTube Videoları',
        youtubeVideosTitle: 'Sora 2 Video Modeli Hakkında YouTube Videoları',
        youtubeVideoTitle: 'Sora 2 Video Modeli Hakkında YouTube Videoları',

        // X paylaşımları
        xPostsTitle: 'Sora 2 Video Modeli Hakkında X Paylaşımları',

        // Diğer modeller
        exploreModelsTitle: 'Diğer Modelleri Keşfedin',
        veo31Title: 'Google Veo 3.1 AI Video Üretici',
        veo3Title: 'Google Veo 3 AI Video Üretici',
        veo3FastTitle: 'Google Veo 3 Fast AI Video Üretici',
        klingTitle: 'Kling AI Video Üretici',
        hailuoTitle: 'Hailuo AI Video Üretici',
        runwayTitle: 'Runway AI Video Üretici',
        seedanceTitle: 'Seedance 1.0 Pro Video Üretici',
        wanAITitle: 'Wan AI Video Üretici',

        // SSS
        faqTitle: 'Sıkça Sorulan Sorular',

        // CTA
        ctaTitle: 'Oluşturmaya hazır mısınız?',
        ctaSubtitle:
            'Sora 2’yi şimdi deneyin ve yaratıcılığınızı harika videolara dönüştürün',
        ctaDescription:
            'Sora 2’yi şimdi deneyin ve yaratıcılığınızı harika videolara dönüştürün',
        ctaButton: 'WeryAI’de Sora 2’yi deneyin',
        ctaNote: 'Kredi kartı gerekmez',
        ctaDisclaimer: 'Kredi kartı gerekmez',

        // Video oynatma
        videoNotSupported: 'Tarayıcınız video oynatmayı desteklemiyor',
        videoUnsupported: 'Tarayıcınız video oynatmayı desteklemiyor',
        videoLoadingError: 'Video yüklenemedi',
        videoLoadError: 'Video yüklenemedi',
        videoReload: 'Yeniden yükle',
        sora2Tip: 'Sora 2, gerçek kişilerin yakın planları için sıkı inceleme uygular. Başarı oranını artırmak için uzak plan veya önden olmayan fotoğraflar yüklemeniz önerilir.',
    },
}
